import React from 'react'
import { OtColors } from 'util/OtColors'

export const ArrowIcon = ({
	color = OtColors.gray,
	direction,
	margin,
	size = 22,
	...props
}) => {
	let rotation = 0
	let topMargin = margin ? margin : '0'
	if (direction) {
		switch (direction.toLowerCase()) {
			case 'top':
				rotation = '-180'
				break
			case 'up':
				rotation = '-180'
				break
			case 'right':
				rotation = '-90'
				break
			case 'bottom':
				rotation = '0'
				break
			case 'down':
				rotation = '0'
				break
			case 'left':
				rotation = '-270'
				break
			default:
				rotation = '0'
		}
	}

	return (
		<svg
			style={{ marginTop: topMargin }}
			width={`${size}px`}
			height={`${size}px`}
			viewBox='0 0 22 14'
			{...props}
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g
					transform='translate(-291.000000, -386.000000)'
					fillRule='nonzero'
					fill={color}
					className='ot_svg_fill'
				>
					<g transform='translate(287.000000, 386.000000)'>
						<g
							transform={`translate(15.000000, 7.000000) rotate(${rotation}) translate(-15.000000, -7.000000) translate(8.000000, -4.000000)`}
						>
							<g>
								<path d='M7.72375065,21.4776984 L13.6740201,15.7069902 C14.0150251,15.3159672 14.1557951,14.5661279 13.7615201,14.1290492 C13.3731951,13.6985705 12.6200651,13.7113738 12.2302001,14.1402295 L8.05186515,18.1977508 L8.05186515,1.21260754 C8.05186515,0.615073115 7.58175565,0.130604262 7.00184065,0.130604262 C6.42192565,0.130604262 5.95180565,0.615073115 5.95180565,1.21260754 L5.95180565,18.1977508 L1.77347065,14.1402295 C1.41454565,13.7710262 0.63492065,13.7027902 0.24215065,14.1290492 C-0.15058435,14.5552361 -0.02510935,15.3320164 0.32968565,15.7069902 L6.27993065,21.4776984 C6.77091065,21.886718 7.23886065,21.8475869 7.72375065,21.4776984 L7.72375065,21.4776984 Z'></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const CalendarIcon = ({
	color = OtColors.gray,
	size = '20',
	...props
}) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 20 20' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g
				transform='translate(-50.000000, -721.000000)'
				fill={color}
				className='ot_svg_fill'
			>
				<g transform='translate(50.000000, 721.000000)'>
					<path d='M17.9971,18 L2.0001,18 L2.0001,7 L17.9991,7 L17.9971,18 Z M18.0001,3 L17.0001,3 L17.0001,0 L15.0001,0 L15.0001,5 L14.0001,5 L14.0001,3 L7.0001,3 L7.0001,0 L5.0001,0 L5.0001,5 L4.0001,5 L4.0001,3 L2.0001,3 C0.8971,3 0.0001,3.898 0.0001,5 L0.0001,18 C0.0001,19.103 0.8971,20 2.0001,20 L18.0001,20 C19.1031,20 20.0001,19.103 20.0001,18 L20.0001,5 C20.0001,3.898 19.1031,3 18.0001,3 L18.0001,3 Z'></path>
				</g>
			</g>
		</g>
	</svg>
)

export const CaretIcon = ({
	color = OtColors.gray,
	direction,
	cursor,
	size = 12,
}) => {
	size = parseInt(size)
	let rotation = 0
	if (direction) {
		switch (direction.toLowerCase()) {
			case 'up':
				rotation = '-180'
				break
			case 'right':
				rotation = '-90'
				break
			case 'down':
				rotation = '0'
				break
			case 'left':
				rotation = '-270'
				break
			default:
				rotation = '0'
		}
	}
	return (
		<svg
			style={{
				transform: `rotate(${rotation}deg)`,
				transition: '150ms ease-in-out',
				cursor: cursor || 'auto',
			}}
			width={`${size}px`}
			height={`${size}px`}
			viewBox='0 0 10 5'
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g
					transform='translate(-969.000000, -720.000000)'
					fill={color}
					className='ot_svg_fill'
				>
					<g transform='translate(219.000000, 571.000000)'>
						<g transform='translate(0.000000, 93.000000)'>
							<g transform='translate(0.511381, 43.000000)'>
								<g transform='translate(690.678300, 0.000000)'>
									<polygon points='58.9438543 13 68.0121396 13 63.477997 17.5'></polygon>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const CartIcon = ({ color = OtColors.gray, size = '28' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 28 28'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g
				transform='translate(-331.000000, -79.000000)'
				fill={color}
				className='ot_svg_fill'
			>
				<g transform='translate(-2.000000, 77.000000)'>
					<g transform='translate(337.000000, 4.000000)'>
						<path d='M12.2046,13 L3.7806,13 L2.2806,7 L13.5886,7 L12.2046,13 Z M15.9996,0 C15.5346,0 15.1306,0.321 15.0256,0.774 L14.0506,5 L0.9996,5 C0.6916,5 0.4016,5.142 0.2116,5.385 C0.0226,5.627 -0.0454,5.944 0.0296,6.243 L2.0296,14.243 C2.1416,14.687 2.5406,15 2.9996,15 L12.9996,15 C13.4656,15 13.8696,14.679 13.9746,14.225 L16.7956,2 L19.9996,2 L19.9996,0 L15.9996,0 Z'></path>
						<path d='M4,16 C2.896,16 2,16.896 2,18 C2,19.106 2.896,20 4,20 C5.104,20 6,19.106 6,18 C6,16.896 5.104,16 4,16'></path>
						<path d='M12,16 C10.896,16 10,16.896 10,18 C10,19.106 10.896,20 12,20 C13.104,20 14,19.106 14,18 C14,16.896 13.104,16 12,16'></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const FilterIcon = ({ color = OtColors.gray, size = '14' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 13'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-496.000000, -98.000000)' fill={color}>
				<g transform='translate(430.000000, 84.000000)'>
					<g transform='translate(20.000000, 12.000000)'>
						<g transform='translate(46.000000, 2.000000)'>
							<path d='M7.7,4.2 L6.3,4.2 L6.3,1.4 L7.7,1.4 L7.7,4.2 Z M9.1,2.1 L9.1,0.7 C9.1,0.3136 8.7864,0 8.4,0 L5.6,0 C5.2136,0 4.9,0.3136 4.9,0.7 L4.9,2.1 L0,2.1 L0,3.5 L4.9,3.5 L4.9,4.9 C4.9,5.2864 5.2136,5.6 5.6,5.6 L8.4,5.6 C8.7864,5.6 9.1,5.2864 9.1,4.9 L9.1,3.5 L14,3.5 L14,2.1 L9.1,2.1 Z'></path>
							<path d='M11.2,11.2 L9.8,11.2 L9.8,8.4 L11.2,8.4 L11.2,11.2 Z M12.6,7.7 C12.6,7.3136 12.2864,7 11.9,7 L9.1,7 C8.7136,7 8.4,7.3136 8.4,7.7 L8.4,9.1 L0,9.1 L0,10.5 L8.4,10.5 L8.4,11.9 C8.4,12.2864 8.7136,12.6 9.1,12.6 L11.9,12.6 C12.2864,12.6 12.6,12.2864 12.6,11.9 L12.6,10.5 L14,10.5 L14,9.1 L12.6,9.1 L12.6,7.7 Z'></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const FullLock = ({ color = '#6B849C', size = '20' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 20'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-914.000000, -319.000000)' fill={color}>
				<g transform='translate(914.000000, 319.000000)'>
					<path d='M8.5,14.5 C8.5,15.328 7.828,16 7,16 C6.172,16 5.5,15.328 5.5,14.5 C5.5,13.672 6.172,13 7,13 C7.828,13 8.5,13.672 8.5,14.5'></path>
					<path d='M2,18 L2,11 L12,11 L12.002,18 L2,18 Z M4,5 C4,3.346 5.346,2 7,2 C8.654,2 10,3.346 10,5 L10,9 L4,9 L4,5 Z M12,9 L12,5 C12,2.243 9.757,0 7,0 C4.243,0 2,2.243 2,5 L2,9 C0.897,9 0,9.896 0,11 L0,18 C0,19.103 0.897,20 2,20 L12,20 C13.103,20 14,19.103 14,18 L14,11 C14,9.896 13.103,9 12,9 L12,9 Z'></path>
				</g>
			</g>
		</g>
	</svg>
)

export const MobileCalendarIcon = ({ size = '14' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 14'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-30.000000, -242.000000)'>
				<g transform='translate(30.000000, 240.000000)'>
					<g transform='translate(0.000000, 2.000000)'>
						<path
							d='M12.5979,12.6 L1.4,12.6 L1.4,4.9 L12.5993,4.9 L12.5979,12.6 Z M12.6,2.1 L11.9,2.1 L11.9,0 L10.5,0 L10.5,3.5 L9.8,3.5 L9.8,2.1 L4.9,2.1 L4.9,0 L3.5,0 L3.5,3.5 L2.8,3.5 L2.8,2.1 L1.4,2.1 C0.6279,2.1 0,2.7286 0,3.5 L0,12.6 C0,13.3721 0.6279,14 1.4,14 L12.6,14 C13.3721,14 14,13.3721 14,12.6 L14,3.5 C14,2.7286 13.3721,2.1 12.6,2.1 L12.6,2.1 Z'
							fill='#D6DDE7'
						></path>
						<polygon fill='#3B454A' points='6 9 3 9 3 6 6 6'></polygon>
						<polygon fill='#3B454A' points='10 9 7 9 7 6 10 6'></polygon>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const MobilePackagesIcon = ({ size = '16' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 14'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-30.000000, -289.000000)'>
				<g transform='translate(30.000000, 287.000000)'>
					<g transform='translate(0.000000, 2.000000)'>
						<polygon
							fill='#D6DDE7'
							points='9.91666667 4.66666667 7.58333333 4.66666667 7.58333333 5.83333333 9.91666667 5.83333333'
						></polygon>
						<polygon
							fill='#D6DDE7'
							points='5.83333333 4.66666667 1.75 4.66666667 1.75 5.83333333 5.83333333 5.83333333'
						></polygon>
						<polygon
							fill='#D6DDE7'
							points='1.75 7.58333333 4.66666667 7.58333333 4.66666667 6.41666667 1.75 6.41666667'
						></polygon>
						<path
							d='M10.5,1.16666667 L10.5,2.91666667 L1.16666667,2.91666667 L1.16666667,1.16666667 L10.5,1.16666667 Z M1.16666667,4.08333333 L10.4994167,4.08333333 L10.4988333,6.41666667 L11.6666667,6.41666667 L11.6666667,1.16666667 C11.6666667,0.52325 11.1434167,0 10.5,0 L1.16666667,0 C0.52325,0 0,0.52325 0,1.16666667 L0,8.16666667 C0,8.81008333 0.52325,9.33333333 1.16666667,9.33333333 L6.41666667,9.33333333 L6.41666667,8.16666667 L1.16666667,8.16666667 L1.16666667,4.08333333 Z'
							fill='#D6DDE7'
						></path>
						<polygon
							fill='#3B454A'
							points='14 9.49993333 11.4998333 9.49993333 10.5 6.99976667 9.49958333 9.49993333 7 9.49993333 9.163 11.3257667 7.99983333 13.9997667 10.5 12.3466 12.9995833 13.9997667 11.837 11.3257667'
						></polygon>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const MobileProductsIcon = ({ size = '16' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 14'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-30.000000, -336.000000)'>
				<g transform='translate(30.000000, 334.000000)'>
					<g transform='translate(0.000000, 2.000000)'>
						<path d='M9.91666667,3.25873333 L9.16241667,2.50506667 C9.04866667,2.39073333 8.89933333,2.33356667 8.75,2.33356667 C8.60066667,2.33356667 8.45133333,2.39073333 8.33758333,2.50506667 L7.58333333,3.25873333 L7.58333333,1.1669 L9.91666667,1.1669 L9.91666667,3.25873333 Z M12.8333333,0.000233333333 L4.66666667,0.000233333333 C4.02325,0.000233333333 3.5,0.523483333 3.5,1.1669 L3.5,6.4169 L4.66666667,6.4169 L4.66666667,1.1669 L6.41666667,1.1669 L6.41666667,4.6669 C6.41666667,4.90256667 6.559,5.11548333 6.77658333,5.2059 C6.99416667,5.29631667 7.245,5.24615 7.41241667,5.0799 L8.75,3.74231667 L10.0875833,5.0799 C10.199,5.19131667 10.3483333,5.25023333 10.5,5.25023333 C10.57525,5.25023333 10.6510833,5.23565 10.7234167,5.2059 C10.941,5.11548333 11.0833333,4.90256667 11.0833333,4.6669 L11.0833333,1.1669 L12.8333333,1.1669 L12.8315833,8.1669 L8.75,8.1669 L8.75,9.33356667 L12.8333333,9.33356667 C13.47675,9.33356667 14,8.81031667 14,8.1669 L14,1.1669 C14,0.523483333 13.47675,0.000233333333 12.8333333,0.000233333333 L12.8333333,0.000233333333 Z'></path>
						<path
							d='M9.625,12.2502917 L3.5,12.2502917 L3.5,9.75420833 L6.1215,8.880375 L6.29008333,9.21870833 L5.42091667,10.087875 C5.3095,10.1992917 5.25583333,10.3492083 5.25525,10.5002917 L5.25,10.5002917 L5.25,11.083625 L10.5,11.083625 L9.625,12.2502917 Z M1.16666667,9.333625 L2.33333333,9.333625 L2.33333333,12.833625 L1.16666667,12.833625 L1.16666667,9.333625 Z M11.6666667,9.91695833 L7.2415,9.91695833 L7.41241667,9.746625 C7.58975,9.56870833 7.63408333,9.29745833 7.5215,9.072875 L6.93816667,7.90620833 C6.80866667,7.646625 6.50883333,7.52179167 6.23233333,7.613375 L3.45741667,8.53854167 C3.37225,8.32154167 3.16341667,8.16695833 2.91666667,8.16695833 L0.583333333,8.16695833 C0.261333333,8.16695833 0,8.42829167 0,8.75029167 L0,13.4169583 C0,13.7389583 0.261333333,14.0002917 0.583333333,14.0002917 L2.91666667,14.0002917 C3.23866667,14.0002917 3.5,13.7389583 3.5,13.4169583 L9.91666667,13.4169583 C10.1004167,13.4169583 10.2730833,13.330625 10.3833333,13.183625 L12.1333333,10.8502917 C12.26575,10.6735417 12.2873333,10.4372917 12.1881667,10.2395417 C12.0895833,10.0417917 11.88775,9.91695833 11.6666667,9.91695833 L11.6666667,9.91695833 Z'
							fill='#D6DDE7'
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const MobileDonationsIcon = ({ size = '16' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 14'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-30.000000, -382.000000)'>
				<g transform='translate(30.000000, 381.000000)'>
					<g transform='translate(0.000000, 1.000000)'>
						<path
							d='M8.75,1.75029167 L8.75,2.36279167 C8.085,2.49870833 7.58333333,3.08729167 7.58333333,3.79195833 C7.58333333,4.59579167 8.23783333,5.25029167 9.04166667,5.25029167 L9.625,5.25029167 C9.786,5.25029167 9.91666667,5.38095833 9.91666667,5.54195833 C9.91666667,5.70295833 9.786,5.833625 9.625,5.833625 L8.75,5.833625 L8.75,7.583625 L9.91666667,7.583625 L9.91666667,6.971125 C10.5816667,6.83520833 11.0833333,6.246625 11.0833333,5.54195833 C11.0833333,4.738125 10.4288333,4.083625 9.625,4.083625 L9.04166667,4.083625 C8.88066667,4.083625 8.75,3.95295833 8.75,3.79195833 C8.75,3.63095833 8.88066667,3.50029167 9.04166667,3.50029167 L11.0833333,3.50029167 L11.0833333,2.333625 L9.91666667,2.333625 L9.91666667,1.75029167 L8.75,1.75029167 Z'
							fill='#3B454A'
						></path>
						<path
							d='M2.33333333,11.6666667 L1.16666667,11.6666667 L1.16666667,8.16666667 L2.33333333,8.16666667 L2.33333333,11.6666667 Z M11.0833333,10.5 C11.0833333,10.822 10.8214167,11.0833333 10.5,11.0833333 L7.58333333,11.0833333 L7.58333333,12.25 L9.91666667,12.25 C9.91666667,12.572 9.65475,12.8333333 9.33333333,12.8333333 L4.90816667,12.8333333 L3.5,11.4251667 L3.5,8.40875 L4.90816667,7 L7,7 L7,7.58333333 C7,7.90533333 6.73808333,8.16666667 6.41666667,8.16666667 L5.25,8.16666667 L5.25,9.33333333 L6.41666667,9.33333333 C7.3815,9.33333333 8.16666667,8.54875 8.16666667,7.58333333 L8.16666667,6.41666667 C8.16666667,6.09466667 7.90533333,5.83333333 7.58333333,5.83333333 L4.66666667,5.83333333 C4.51208333,5.83333333 4.36391667,5.89458333 4.25425,6.00483333 L3.185,7.07408333 C3.10333333,7.03091667 3.01525,7 2.91666667,7 L0.583333333,7 C0.261333333,7 0,7.26133333 0,7.58333333 L0,12.25 C0,12.5725833 0.261333333,12.8333333 0.583333333,12.8333333 L2.91666667,12.8333333 C3.01525,12.8333333 3.10333333,12.803 3.185,12.7598333 L4.25425,13.8296667 C4.36391667,13.93875 4.51208333,14 4.66666667,14 L9.33333333,14 C10.2981667,14 11.0833333,13.2154167 11.0833333,12.25 L11.0833333,12.1426667 C11.7611667,11.9011667 12.25,11.2600833 12.25,10.5 L12.25,9.91666667 L11.0833333,9.91666667 L11.0833333,10.5 Z'
							fill='#DDE3EB'
						></path>
						<path
							d='M9.33333333,0.000291666667 C6.76025,0.000291666667 4.66666667,2.093875 4.66666667,4.66695833 C4.66666667,4.86470833 4.683,5.058375 4.70691667,5.25029167 L5.88583333,5.25029167 C5.85375,5.060125 5.83333333,4.865875 5.83333333,4.66695833 C5.83333333,2.73729167 7.40308333,1.16695833 9.33333333,1.16695833 C11.2635833,1.16695833 12.8333333,2.73729167 12.8333333,4.66695833 C12.8333333,6.59720833 11.2635833,8.16695833 9.33333333,8.16695833 C9.13441667,8.16695833 8.94016667,8.14654167 8.75,8.11445833 L8.75,9.293375 C8.94133333,9.31729167 9.13558333,9.333625 9.33333333,9.333625 C11.9064167,9.333625 14,7.24004167 14,4.66695833 C14,2.093875 11.9064167,0.000291666667 9.33333333,0.000291666667'
							fill='#3B454A'
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const MobileGiftCardsIcon = ({ size = '16' }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 14'>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-30.000000, -430.000000)'>
				<g transform='translate(30.000000, 428.000000)'>
					<g transform='translate(0.000000, 2.000000)'>
						<path
							d='M12.6,7 L9.8,7 L9.8,5.6 L12.6,5.6 L12.6,7 Z M11.9,12.6 L9.8,12.6 L9.8,8.4 L11.9,8.4 L11.9,12.6 Z M9.3051,1.6058 C9.4374,1.4735 9.6131,1.4007 9.8,1.4007 C9.9869,1.4007 10.1626,1.4735 10.2942,1.6051 C10.5672,1.8781 10.5679,2.3226 10.2942,2.5949 C9.8812,3.0086 9.1399,3.2494 8.5218,3.3782 C8.6506,2.7601 8.8921,2.0188 9.3051,1.6058 L9.3051,1.6058 Z M8.4,7 L5.6,7 L5.6,5.6 L8.4,5.6 L8.4,7 Z M8.4,12.6 L5.6,12.6 L5.6,8.4 L8.4,8.4 L8.4,12.6 Z M3.7051,2.5949 C3.5728,2.4626 3.5,2.2869 3.5,2.1 C3.5,1.9138 3.5728,1.7374 3.7058,1.6051 C3.8374,1.4735 4.0124,1.4007 4.2,1.4007 C4.3869,1.4007 4.5626,1.4735 4.6949,1.6058 C5.1079,2.0181 5.3487,2.7594 5.4775,3.3768 C4.8615,3.2473 4.116,3.0058 3.7051,2.5949 L3.7051,2.5949 Z M4.2,7 L1.4,7 L1.4,5.6 L4.2,5.6 L4.2,7 Z M4.2,12.6 L2.1,12.6 L2.1,8.4 L4.2,8.4 L4.2,12.6 Z M12.6,4.2 L10.4195,4.2 C10.7352,4.0362 11.0348,3.8353 11.2847,3.5847 C12.1037,2.7664 12.1037,1.4343 11.2847,0.6153 C10.4909,-0.1771 9.1091,-0.1771 8.3153,0.6153 C7.1701,1.7605 7.014,3.9179 7,4.1601 C6.986,3.9179 6.8299,1.7605 5.6847,0.6153 C4.8909,-0.1771 3.5077,-0.1771 2.7153,0.6153 C2.3184,1.0122 2.1,1.5393 2.1,2.1 C2.1,2.6607 2.3184,3.1878 2.7146,3.5847 C2.9652,3.8353 3.2641,4.0355 3.5805,4.2 L1.4,4.2 C0.6279,4.2 0,4.8279 0,5.6 L0,7.7 C0,8.0864 0.3136,8.4 0.7,8.4 L0.7,12.6 C0.7,13.3721 1.3279,14 2.1,14 L11.9,14 C12.6721,14 13.3,13.3721 13.3,12.6 L13.3,8.4 C13.6864,8.4 14,8.0864 14,7.7 L14,5.6 C14,4.8279 13.3721,4.2 12.6,4.2 L12.6,4.2 Z'
							fill='#DDE3EB'
						></path>
						<g transform='translate(2.000000, 0.000000)'>
							<path
								d='M8.4195,4.2 C8.7352,4.0362 9.0348,3.8353 9.2847,3.5847 C10.1037,2.7664 10.1037,1.4343 9.2847,0.6153 C8.4909,-0.1771 7.1091,-0.1771 6.3153,0.6153 C5.1701,1.7605 5.014,3.9179 5,4.1601 C4.986,3.9179 4.8299,1.7605 3.6847,0.6153 C2.8909,-0.1771 1.5077,-0.1771 0.7153,0.6153 C0.3184,1.0122 0.1,1.5393 0.1,2.1 C0.1,2.6607 0.3184,3.1878 0.7146,3.5847 C0.9652,3.8353 1.2641,4.0355 1.5805,4.2 L10.6,4.2 L8.4195,4.2 Z'
								fill='#3B454A'
							></path>
							<path
								d='M7.8,1.4007 C7.9869,1.4007 8.1626,1.4735 8.2942,1.6051 C8.5672,1.8781 8.5679,2.3226 8.2942,2.5949 C7.8812,3.0086 7.1399,3.2494 6.5218,3.3782 C6.6506,2.7601 6.8921,2.0188 7.3051,1.6058 C7.4374,1.4735 7.6131,1.4007 7.8,1.4007 Z'
								fill='#FFFFFF'
							></path>
							<path
								d='M1.7051,2.5949 C1.5728,2.4626 1.5,2.2869 1.5,2.1 C1.5,1.9138 1.5728,1.7374 1.7058,1.6051 C1.8374,1.4735 2.0124,1.4007 2.2,1.4007 C2.3869,1.4007 2.5626,1.4735 2.6949,1.6058 C3.1079,2.0181 3.3487,2.7594 3.4775,3.3768 C2.8615,3.2473 2.116,3.0058 1.7051,2.5949 L1.7051,2.5949 Z'
								fill='#FFFFFF'
							></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const CheckIcon = ({ size = '80' }) => {
	let base = 80
	size = parseInt(size)
	let scaleFactor = size / base
	return (
		<svg
			width={`${size}px`}
			height={`${size}px`}
			viewBox={`0 0 ${size} ${size}`}
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g transform={`scale(${scaleFactor} ${scaleFactor})`}>
					<circle fill='#B9F4BC' cx='40' cy='40' r='40'></circle>
					<g transform='translate(25.000000, 25.000000)' fill='#29B87A'>
						<polygon points='12.2533077 29.0322581 0 16.8725751 5.35703464 11.5551575 11.2867387 17.4410095 23.8369862 0 30 4.36701945'></polygon>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const CheckMarkIcon = ({ color = OtColors.green, size = '8' }) => {
	size = parseInt(size)
	return (
		<svg width={`${size * 1.37}px`} height={`${size}px`} viewBox='0 0 11 8'>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g
					transform='translate(-194.000000, -140.000000)'
					fill={color}
					className='ot_svg_fill'
					fillRule='nonzero'
				>
					<g transform='translate(115.000000, 132.000000)'>
						<g transform='translate(79.000000, 0.000000)'>
							<g transform='translate(0.000000, 8.000000)'>
								<g>
									<path d='M9.625,0.41025641 L4.10535714,6.17435897 L1.29642857,3.24102564 C1.02142857,2.95384615 0.569642857,2.95384615 0.294642857,3.24102564 C0.0196428571,3.52820513 0.0196428571,4 0.294642857,4.28717949 L3.59464286,7.73333333 C3.73214286,7.87692308 3.90892857,7.95897436 4.10535714,7.95897436 C4.30178571,7.95897436 4.47857143,7.87692308 4.61607143,7.73333333 L10.6267857,1.45641026 C10.9017857,1.16923077 10.9017857,0.697435897 10.6267857,0.41025641 C10.3517857,0.123076923 9.91964286,0.123076923 9.625,0.41025641 Z'></path>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const ChevronIcon = ({
	color = OtColors.gray,
	direction = 'right',
	size = 12,
}) => {
	let sizeMin = parseInt(size)
	let sizeMax = sizeMin * 1.636
	let rotation = 0
	let isVertical = true

	if (direction) {
		direction = direction.toLowerCase()
		switch (direction.toLowerCase()) {
			case 'up':
				rotation = '180'
				break
			case 'top':
				rotation = '180'
				break
			case 'right':
				rotation = '-90'
				break
			case 'bottom':
				rotation = '0'
				break
			case 'down':
				rotation = '0'
				break
			case 'left':
				rotation = '90'
				break
			default:
				rotation = '0'
		}
	}

	return (
		<svg
			width={`${isVertical ? sizeMin : sizeMax}px`}
			height={`${isVertical ? sizeMax : sizeMin}px`}
			viewBox='0 0 18 11'
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g
					transform='translate(-1098.000000, -382.000000)'
					fill={color}
					className={'ot_svg_fill'}
				>
					<g transform='translate(905.000000, 271.000000)'>
						<g
							transform={`translate(202.000000, 116.500000) rotate(${rotation}.000000) translate(-202.000000, -116.500000) translate(193.000000, 111.000000)`}
						>
							<polygon points='9 10.4141 0.586 2.0001 2 0.5861 9 7.5861 16 0.5861 17.414 2.0001'></polygon>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const CloseIcon = ({ color = OtColors.gray, size = '10', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 20 20' {...props}>
		<g stroke='none' strokeWidth='2' fill='none' fillRule='evenodd'>
			<g transform='translate(-433.000000, -205.000000)' fill={color}>
				<g transform='translate(433.000000, 205.000000)'>
					<polygon points='19.6744444 1.89666667 18.1033333 0.325555556 10 8.42888889 1.89666667 0.325555556 0.325555556 1.89666667 8.42888889 10 0.325555556 18.1033333 1.89666667 19.6744444 10 11.5711111 18.1033333 19.6744444 19.6744444 18.1033333 11.5711111 10'></polygon>
				</g>
			</g>
		</g>
	</svg>
)

export const PopUpCloseIcon = ({
	color = OtColors.gray,
	size = '10',
	...props
}) => (
	<svg
		width={`${size}px`}
		height={`${size}px`}
		viewBox='0 0 20 20'
		{...props}
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g stroke='none' strokeWidth='2' fill='none' fillRule='evenodd'>
			<g transform='translate(-433.000000, -205.000000)' fill={color}>
				<g transform='translate(433.000000, 205.000000)'>
					<path
						d='M9.21401 8L15.3663 0.666406C15.4695 0.544531 15.3828 0.359375 15.2234 0.359375H13.3531C13.2429 0.359375 13.1374 0.408594 13.0648 0.492969L7.99057 6.54219L2.91635 0.492969C2.84604 0.408594 2.74057 0.359375 2.62807 0.359375H0.757756C0.598381 0.359375 0.511662 0.544531 0.614787 0.666406L6.76713 8L0.614787 15.3336C0.591686 15.3608 0.576866 15.394 0.572086 15.4293C0.567305 15.4647 0.572766 15.5006 0.587819 15.533C0.602872 15.5653 0.626885 15.5926 0.657008 15.6117C0.68713 15.6308 0.722097 15.6408 0.757756 15.6406H2.62807C2.73822 15.6406 2.84369 15.5914 2.91635 15.507L7.99057 9.45781L13.0648 15.507C13.1351 15.5914 13.2406 15.6406 13.3531 15.6406H15.2234C15.3828 15.6406 15.4695 15.4555 15.3663 15.3336L9.21401 8Z'
						fill='#343A40'
					></path>
				</g>
			</g>
		</g>
	</svg>
)

export const HelpIcon = ({ color = OtColors.gray, size = '12', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 20 20' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-794.000000, -1681.000000)' fill={color}>
				<g transform='translate(794.000000, 1681.000000)'>
					<path d='M10,2 C5.589,2 2,5.589 2,10 C2,14.411 5.589,18 10,18 C14.411,18 18,14.411 18,10 C18,5.589 14.411,2 10,2 M10,20 C4.486,20 0,15.515 0,10 C0,4.486 4.486,0 10,0 C15.514,0 20,4.486 20,10 C20,15.515 15.514,20 10,20'></path>
					<path d='M11,13 L9,13 L9,10 L10,10 C11.103,10 12,9.103 12,8 C12,6.896 11.103,6 10,6 C8.897,6 8,6.896 8,8 L6,8 C6,5.794 7.794,4 10,4 C12.206,4 14,5.794 14,8 C14,9.86 12.723,11.428 11,11.874 L11,13 Z'></path>
					<path d='M11.25,15 C11.25,15.69 10.69,16.25 10,16.25 C9.31,16.25 8.75,15.69 8.75,15 C8.75,14.31 9.31,13.75 10,13.75 C10.69,13.75 11.25,14.31 11.25,15'></path>
				</g>
			</g>
		</g>
	</svg>
)

export const HomeIcon = ({ color = OtColors.gray_dark, size = 16 }) => {
	size = parseInt(size)
	let width = size
	//scale(${scaleFactor} ${scaleFactor})
	return (
		<svg width={`${width}px`} height={`${size}px`} viewBox={'0 0 20 19'}>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g
					transform='translate(-399.000000, -847.000000)'
					fill={color}
					className='ot_svg_fill'
				>
					<g transform='translate(156.000000, 172.000000)'>
						<g transform='translate(242.000000, 675.000000)'>
							<path d='M8.99870002,12 L12.9987,12 C13.5507,12 13.9987,12.448 13.9987,13 L13.9987,17 L16.0007,17 L15.9987,10 C15.9987,9.448 16.4467,9 16.9987,9 L17.5847,9 L10.9987,2.415 L4.41270002,9 L4.99870002,9 C5.55070002,9 5.99870002,9.448 5.99870002,10 L5.99870002,17 L7.99870002,17 L7.99870002,13 C7.99870002,12.448 8.44670002,12 8.99870002,12 M15.9987,19 L13.9987,19 C12.8957,19 11.9987,18.103 11.9987,17 L11.9987,14 L9.99870002,14 L9.99870002,17 C9.99870002,18.103 9.10170002,19 7.99870002,19 L5.99870002,19 C4.89570002,19 3.99870002,18.103 3.99870002,17 L3.99870002,11 L1.99870002,11 C1.59470002,11 1.22970002,10.756 1.07470002,10.382 C0.919700024,10.009 1.00570002,9.579 1.29170002,9.293 L10.2917,0.293 C10.6827,-0.098 11.3147,-0.098 11.7057,0.293 L20.7057,9.293 C20.9917,9.579 21.0777,10.009 20.9227,10.382 C20.7677,10.756 20.4027,11 19.9987,11 L17.9987,11 L17.9987,17 C17.9987,18.103 17.1017,19 15.9987,19'></path>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const FacebookIcon = ({ color = OtColors.gray, size = '14' }) => {
	size = parseInt(size)
	let width = size * 0.62
	return (
		<svg width={`${width}px`} height={`${size}px`} viewBox='0 0 13 21'>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g
					transform='translate(-5.000000, -1.000000)'
					fill={color}
					fillRule='nonzero'
					className='ot_svg_fill'
				>
					<path d='M13,22 L13,13 L17.3,13 L17.85,9 L13,9 L13,7.06 C13,5.82 13.34,4.98 15.11,4.98 L18,4.98 L18,1.16 C17.61,1.12 16.27,1 14.71,1 C11.45,1 9,2.99 9,6.64 L9,9 L5,9 L5,13 L9,13 L9,22 L13,22 Z'></path>
				</g>
			</g>
		</svg>
	)
}

export const LoginIcon = ({ color = OtColors.gray, size = '20', ...props }) => {
	size = parseInt(size)
	return (
		<svg
			width={`${size * 1.03}px`}
			height={`${size}px`}
			viewBox='0 0 31 30'
			{...props}
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g fillRule='nonzero' fill={color} className='ot_svg_fill'>
					<g>
						<path d='M29.2386364,0 L9.82840909,0 C8.84204545,0 8.10227273,0.76744186 8.10227273,1.74418605 L8.10227273,9.1744186 C8.10227273,10.1511628 8.87727273,10.9186047 9.86363636,10.9186047 C10.85,10.9186047 11.625,10.1511628 11.625,9.1744186 L11.625,3.48837209 L27.4772727,3.48837209 L27.4772727,26.5116279 L11.625,26.5116279 L11.625,20.8255814 C11.625,19.8488372 10.85,19.0813953 9.86363636,19.0813953 C8.87727273,19.0813953 8.10227273,19.8488372 8.10227273,20.8255814 L8.10227273,28.255814 C8.10227273,29.2325581 8.84204545,30 9.82840909,30 L29.2386364,30 C30.225,30 31,29.2325581 31,28.255814 L31,1.74418605 C31,0.76744186 30.225,0 29.2386364,0 Z'></path>
						<path d='M15.7818182,19.255814 C15.4647727,19.5697674 15.2534091,20.0232558 15.2886364,20.4767442 C15.2886364,20.9302326 15.4647727,21.3837209 15.8170455,21.6976744 C16.1340909,22.0116279 16.5920455,22.1860465 17.05,22.1860465 C17.5079545,22.1860465 17.9659091,22.0116279 18.3181818,21.6627907 L23.8488636,16.1511628 C24.5181818,15.4883721 24.5181818,14.372093 23.8488636,13.7093023 L18.2829545,8.19767442 C17.9659091,7.88372093 17.5079545,7.6744186 17.05,7.6744186 C16.5920455,7.6744186 16.1340909,7.84883721 15.8170455,8.1627907 C15.5,8.47674419 15.2886364,8.93023256 15.2886364,9.38372093 C15.2886364,9.8372093 15.4647727,10.2906977 15.7818182,10.6046512 L18.3534091,13.1511628 L1.76136364,13.255814 C0.775,13.255814 0,14.0581395 0,15 C0,15.9767442 0.810227273,16.744186 1.76136364,16.744186 L18.3181818,16.7093023 L15.7818182,19.255814 Z'></path>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const MenuIcon = ({ color = OtColors.gray, size = '16', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 32 32' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g fillRule='nonzero' fill={color} className='ot_svg_fill'>
				<path d='M30.4,14 L1.6,14 C0.716444444,14 0,14.8955556 0,16 C0,17.1044444 0.716444444,18 1.6,18 L30.4,18 C31.2835556,18 32,17.1044444 32,16 C32,14.8955556 31.2835556,14 30.4,14 Z'></path>
				<path d='M30.4,0 L1.6,0 C0.716444444,0 0,0.895555556 0,2 C0,3.10444444 0.716444444,4 1.6,4 L30.4,4 C31.2835556,4 32,3.10444444 32,2 C32,0.895555556 31.2835556,0 30.4,0 Z'></path>
				<path d='M30.4,28 L1.6,28 C0.716444444,28 0,28.8955556 0,30 C0,31.1044444 0.716444444,32 1.6,32 L30.4,32 C31.2835556,32 32,31.1044444 32,30 C32,28.8955556 31.2835556,28 30.4,28 Z'></path>
			</g>
		</g>
	</svg>
)

export const MinusIcon = ({
	color = OtColors.gray_dark,
	x = 0,
	y = 0,
	size = '14',
	...props
}) => {
	let hSize = parseInt(size) * 0.112
	return (
		<svg
			width={`${size}px`}
			height={`${hSize}px`}
			viewBox='0 0 18 2'
			{...props}
		>
			<g
				stroke='none'
				strokeWidth='1'
				fill='none'
				fillRule='evenodd'
				transform={`translate(${x} ${y})`}
			>
				<g transform='translate(-773.000000, -273.000000)'>
					<g
						transform='translate(751.000000, 145.000000)'
						fill={color}
						className='ot_svg_fill'
					>
						<g transform='translate(20.000000, 20.000000)'>
							<g transform='translate(2.000000, 108.000000)'>
								<polygon points='18 2 0 2 0 0 18 0'></polygon>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const PackageIcon = ({ size = '13', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 25 25' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-705.000000, -754.000000)'>
				<g transform='translate(644.000000, 520.000000)'>
					<g transform='translate(61.000000, 77.000000)'>
						<g transform='translate(0.000000, 157.000000)'>
							<g>
								<circle
									fill='#FFE19A'
									opacity='0.231640625'
									cx='12.5'
									cy='12.5'
									r='12.5'
								></circle>
								<g transform='translate(6.000000, 6.000000)' fill='#FEC231'>
									<path d='M3.321,1.2 L5.4,1.2 L5.4,3.6 L1.7214,3.6 L3.321,1.2 Z M10.2792,3.6 L6.6,3.6 L6.6,1.2 L8.679,1.2 L10.2792,3.6 Z M1.2,4.8 L10.8,4.8 L10.8,9 L12,9 L12,4.2 C12,4.1958 11.9982,4.1928 11.9976,4.1886 C11.9964,4.119 11.982,4.0512 11.9568,3.9858 C11.9502,3.9684 11.9412,3.954 11.9334,3.9372 C11.922,3.9144 11.9142,3.8892 11.8992,3.867 L9.4992,0.267 C9.3876,0.1002 9.201,0 9,0 L3,0 C2.7996,0 2.6118,0.1002 2.5008,0.267 L0.1008,3.867 C0.0858,3.8892 0.078,3.9144 0.0666,3.9372 C0.0588,3.954 0.0498,3.9684 0.0432,3.9858 C0.018,4.0512 0.0036,4.119 0.0024,4.1886 C0.0024,4.1928 0,4.1958 0,4.2 L0,11.4 C0,11.7312 0.2688,12 0.6,12 L7.8,12 L7.8,10.8 L1.2,10.8 L1.2,4.8 Z'></path>
									<polygon points='12.2489909 10 9.96887614 12.4114591 8.75100914 11.1234377 8 11.9177082 9.96887614 14 13 10.7942705'></polygon>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const PackageHolderIcon = ({ size = '25', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 25 25' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-89.000000, -319.000000)'>
				<g transform='translate(89.000000, 319.000000)'>
					<path
						d='M15.9166667,9.25873333 L15.1624167,8.50506667 C15.0486667,8.39073333 14.8993333,8.33356667 14.75,8.33356667 C14.6006667,8.33356667 14.4513333,8.39073333 14.3375833,8.50506667 L13.5833333,9.25873333 L13.5833333,7.1669 L15.9166667,7.1669 L15.9166667,9.25873333 Z M18.8333333,6.00023333 L10.6666667,6.00023333 C10.02325,6.00023333 9.5,6.52348333 9.5,7.1669 L9.5,12.4169 L10.6666667,12.4169 L10.6666667,7.1669 L12.4166667,7.1669 L12.4166667,10.6669 C12.4166667,10.9025667 12.559,11.1154833 12.7765833,11.2059 C12.9941667,11.2963167 13.245,11.24615 13.4124167,11.0799 L14.75,9.74231667 L16.0875833,11.0799 C16.199,11.1913167 16.3483333,11.2502333 16.5,11.2502333 C16.57525,11.2502333 16.6510833,11.23565 16.7234167,11.2059 C16.941,11.1154833 17.0833333,10.9025667 17.0833333,10.6669 L17.0833333,7.1669 L18.8333333,7.1669 L18.8315833,14.1669 L14.75,14.1669 L14.75,15.3335667 L18.8333333,15.3335667 C19.47675,15.3335667 20,14.8103167 20,14.1669 L20,7.1669 C20,6.52348333 19.47675,6.00023333 18.8333333,6.00023333 L18.8333333,6.00023333 Z'
						fill='#FEC231'
					></path>
					<path
						d='M15.625,18.2502917 L9.5,18.2502917 L9.5,15.7542083 L12.1215,14.880375 L12.2900833,15.2187083 L11.4209167,16.087875 C11.3095,16.1992917 11.2558333,16.3492083 11.25525,16.5002917 L11.25,16.5002917 L11.25,17.083625 L16.5,17.083625 L15.625,18.2502917 Z M7.16666667,15.333625 L8.33333333,15.333625 L8.33333333,18.833625 L7.16666667,18.833625 L7.16666667,15.333625 Z M17.6666667,15.9169583 L13.2415,15.9169583 L13.4124167,15.746625 C13.58975,15.5687083 13.6340833,15.2974583 13.5215,15.072875 L12.9381667,13.9062083 C12.8086667,13.646625 12.5088333,13.5217917 12.2323333,13.613375 L9.45741667,14.5385417 C9.37225,14.3215417 9.16341667,14.1669583 8.91666667,14.1669583 L6.58333333,14.1669583 C6.26133333,14.1669583 6,14.4282917 6,14.7502917 L6,19.4169583 C6,19.7389583 6.26133333,20.0002917 6.58333333,20.0002917 L8.91666667,20.0002917 C9.23866667,20.0002917 9.5,19.7389583 9.5,19.4169583 L15.9166667,19.4169583 C16.1004167,19.4169583 16.2730833,19.330625 16.3833333,19.183625 L18.1333333,16.8502917 C18.26575,16.6735417 18.2873333,16.4372917 18.1881667,16.2395417 C18.0895833,16.0417917 17.88775,15.9169583 17.6666667,15.9169583 L17.6666667,15.9169583 Z'
						fill='#FEC231'
					></path>
					<ellipse
						fill='#FFE19A'
						opacity='0.231640625'
						cx='13'
						cy='12.5'
						rx='13'
						ry='12.5'
					></ellipse>
				</g>
			</g>
		</g>
	</svg>
)

export const RegularShowtimeIcon = ({ size = '25', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 25 25' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-674.000000, -691.000000)'>
				<g transform='translate(644.000000, 332.000000)'>
					<g transform='translate(30.000000, 359.000000)'>
						<g>
							<circle
								fill='#01BEFF'
								opacity='0.101641'
								cx='12.5'
								cy='12.5'
								r='12.5'
							></circle>
							<g transform='translate(8.000000, 6.000000)'>
								<path
									d='M0.00206499537,11.1425278 C-0.0167604007,11.3668207 0.0943464818,11.5815038 0.285581978,11.6903453 C1.39980372,12.4485247 2.63310259,12.7830585 3.95429173,12.8341882 C5.57600885,12.8970046 7.12401157,12.6603474 8.52175029,11.731249 C8.7588739,11.6015248 8.89906766,11.3395257 8.87898169,11.063642 C8.86480584,7.96469937 8.86480584,4.86526974 8.87898169,1.76535315 C8.89919322,1.50284732 8.76678623,1.25288416 8.54159648,1.12842401 C7.17079188,0.21101232 5.64972326,-0.04025331 4.05352267,0.00503293543 C2.69264115,0.047397489 1.41823232,0.374627136 0.274241297,1.17371026 C0.0965004493,1.2781206 -0.00635277753,1.47927763 0.0105705048,1.68938912 C0.0119880897,3.26272096 0.0119880897,4.8389745 0.0119880897,6.41522803 C0.0119880897,7.99148156 0.0119880897,9.56773509 0.00206499537,11.1425278 Z'
									fill='#01BEFF'
								></path>
								<path
									d='M2.55995161,6.29530843 C2.55995161,5.32968879 2.5883033,4.36260831 2.54719334,3.39991037 C2.52876474,2.94996961 2.6535122,2.72353837 3.08020526,2.6242008 C3.35238156,2.56138439 3.53808518,2.45620344 3.66283266,2.86670134 C3.78758014,3.27719925 4.17458082,3.47879609 4.61119696,3.46857016 C5.04781311,3.45834424 5.39937417,3.23337385 5.5283744,2.81265002 C5.62902293,2.48249868 5.76936383,2.52048069 5.99901259,2.60082725 C6.61140927,2.79658071 6.61282685,2.79073732 6.61282685,3.46126593 C6.61282685,5.4314611 6.61282685,7.40214323 6.61282685,9.37331231 C6.61282685,9.7239155 6.03161704,10.1738563 5.71266044,10.0745188 C5.60208881,10.0394584 5.6134295,9.92843403 5.58082504,9.85247008 C5.37669281,9.376234 5.01379108,9.09575145 4.5885156,9.12204669 C4.11078949,9.15418532 3.7620636,9.39960755 3.62314028,9.88899111 C3.57068965,10.0759796 3.49272247,10.1022747 3.32119469,10.0584494 C2.56562194,9.86853925 2.56420436,9.87292193 2.56420436,9.06945621 C2.55947908,8.14620112 2.55711643,7.22197215 2.55711643,6.29676927 L2.55995161,6.29530843 Z'
									fill='#E5F8FF'
								></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const NoWebSalesIcon = ({ size = '25', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 25 25' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-677.000000, -815.000000)' fill='#01BEFF'>
				<g transform='translate(677.000000, 815.000000)'>
					<path d='M10,2 C5.589,2 2,5.589 2,10 C2,14.411 5.589,18 10,18 C14.411,18 18,14.411 18,10 C18,5.589 14.411,2 10,2 M10,20 C4.486,20 0,15.515 0,10 C0,4.486 4.486,0 10,0 C15.514,0 20,4.486 20,10 C20,15.515 15.514,20 10,20'></path>
					<path d='M11,13 L11,9 C11,8.448 10.552,8 10,8 L8,8 L8,10 L9,10 L9,13 L7,13 L7,15 L13,15 L13,13 L11,13 Z'></path>
					<path d='M11.25,6 C11.25,6.69 10.69,7.25 10,7.25 C9.31,7.25 8.75,6.69 8.75,6 C8.75,5.31 9.31,4.75 10,4.75 C10.69,4.75 11.25,5.31 11.25,6'></path>
				</g>
			</g>
		</g>
	</svg>
)

export const PencilIcon = ({ color = OtColors.gray, size = 17, ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 17 17' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g
				transform='translate(-302.000000, -213.000000)'
				fillRule='nonzero'
				fill={color}
				className='ot_svg_fill'
			>
				<g transform='translate(302.000000, 213.000000)'>
					<path d='M16.4942874,2.7834912 L14.2185808,0.50608931 C13.8967637,0.184032476 13.4600119,0 13.0002732,0 C12.5405345,0 12.1037828,0.184032476 11.7819657,0.50608931 L1.8745965,10.420839 C1.66771408,10.6278755 1.52979247,10.8809202 1.43784473,11.1569689 L0.0356416655,15.9648173 C-0.0563060761,16.240866 0.0356416655,16.5399188 0.242524084,16.7699594 C0.403432632,16.9309878 0.610315051,17 0.81719747,17 C0.886158276,17 0.978106017,17 1.04706682,16.9769959 L5.85133632,15.5737483 C6.12717955,15.4817321 6.38003584,15.3437077 6.58691826,15.1366712 L16.4942874,5.22192152 C16.8161045,4.89986468 17,4.46278755 17,4.00270636 C17,3.54262517 16.8161045,3.10554804 16.4942874,2.7834912 Z M2.72511311,12.4912043 L4.51809407,14.285521 L1.98953118,15.0216509 L2.72511311,12.4912043 Z M15.3449407,4.0947226 L13.781829,5.65899865 L11.3452139,3.22056834 L12.9083255,1.65629229 C12.9313124,1.63328823 12.9772863,1.63328823 13.0002732,1.63328823 C13.0232602,1.63328823 13.0462471,1.63328823 13.092221,1.65629229 L15.3679276,3.93369418 C15.3909145,3.95669824 15.3909145,4.00270636 15.3909145,4.02571042 C15.3909145,4.04871448 15.3679276,4.07171854 15.3449407,4.0947226 Z'></path>
				</g>
			</g>
		</g>
	</svg>
)

export const PlusIcon = ({
	color = OtColors.gray_dark,
	size = '14',
	...props
}) => (
	<svg
		width={`${size}px`}
		height={`${size}px`}
		viewBox={'0 0 18 18'}
		{...props}
	>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-773.000000, -215.000000)'>
				<g
					transform='translate(751.000000, 145.000000)'
					fill={color}
					className='ot_svg_fill'
				>
					<g transform='translate(20.000000, 20.000000)'>
						<g transform='translate(2.000000, 50.000000)'>
							<polygon points='18 8 10 8 10 0 8 0 8 8 0 8 0 10 8 10 8 18 10 18 10 10 18 10'></polygon>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const ProfileBackground = ({
	width = '250',
	height = '100',
	...props
}) => (
	<svg
		width={`${width}px`}
		height={`${height}px`}
		viewBox='0 0 250 100'
		{...props}
	>
		<defs>
			<linearGradient
				x1='3.4828125%'
				y1='86.7814781%'
				x2='90.4546875%'
				y2='10.8975821%'
				id='linearGradient-1'
			>
				<stop stopColor='#F9F9F9' offset='0%' />
				<stop stopColor='#EEEEEE' offset='100%' />
			</linearGradient>
		</defs>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(0.000000, -64.000000)'>
				<g transform='translate(0.000000, 64.000000)'>
					<polygon
						fill='url(#linearGradient-1)'
						points='0 0 250 0 250 60.1063526 0 100'
					></polygon>
					<path
						d='M12.8784126,46.8985068 L74.7338771,37.1015637 C79.1809792,36.3972119 83.3570577,39.4313105 84.0614094,43.8784126 C84.7657612,48.3255147 81.7316626,52.5015932 77.2845605,53.205945 L15.4290961,63.0028881 C10.981994,63.7072399 6.80591548,60.6731413 6.1015637,56.2260392 C5.39721193,51.7789371 8.43131054,47.6028586 12.8784126,46.8985068 Z'
						fill='#EEEEEE'
						opacity='0.454743304'
					></path>
					<path
						d='M249.217773,44.3879534 L249.217773,26.968442 L189.966432,37.5644764 L189.95663,37.566129 C185.78227,38.2272826 182.934254,42.1472405 183.595408,46.3215999 C184.256561,50.4959594 188.176519,53.3439755 192.356928,52.6819018 L249.217773,44.3879534 Z'
						stroke='#979797'
						opacity='0.117857143'
					></path>
					<path
						d='M0,29.3007368 L42.9192812,22.1122776 C47.3207562,21.3750839 51.4864703,24.3455708 52.223664,28.7470458 C52.2276096,28.7706038 52.2314508,28.7941791 52.2351875,28.8177712 C52.936665,33.2467263 49.9149474,37.4057637 45.4859923,38.1072413 C45.4750621,38.1089725 45.4641283,38.1106813 45.453191,38.1123678 L0,45.1210493 L0,29.3007368 Z'
						fill='#CCCCCC'
						opacity='0.613058036'
					></path>
				</g>
			</g>
		</g>
	</svg>
)

export const LoginIconMobile = ({ size = '25', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 25 25' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-159.000000, -604.000000)'>
				<g transform='translate(65.000000, 600.000000)'>
					<g transform='translate(94.000000, 4.000000)'>
						<polygon
							fill='#3B454A'
							points='11.1130141 6 9.64629558 7.50414277 12.0306215 9.93881453 0 9.93881453 0 12.06331 12.0212794 12.06331 9.64525756 14.5001062 11.1150902 16 16 10.991502'
						></polygon>
						<path
							d='M10.7640616,0 C6.18962076,0 2.30815292,3.0954 1,7.35 L3.17820769,7.35 C4.39628435,4.27665 7.33502226,2.1 10.7640616,2.1 C15.279134,2.1 18.9528123,5.86845 18.9528123,10.5 C18.9528123,15.13155 15.279134,18.9 10.7640616,18.9 C7.33502226,18.9 4.39628435,16.7244 3.17820769,13.65 L1,13.65 C2.30815292,17.9046 6.18962076,21 10.7640616,21 C16.408158,21 21,16.2897 21,10.5 C21,4.7103 16.408158,0 10.7640616,0'
							fill='#DDE3EB'
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const PromoIcon = ({ color = OtColors.gray, size = '13', ...props }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 13 13' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g
				transform='translate(-659.000000, -2658.000000)'
				fillRule='nonzero'
				fill={color}
				className='ot_svg_fill'
			>
				<g transform='translate(633.000000, 2655.000000)'>
					<g transform='translate(8.000000, 3.000000)'>
						<g transform='translate(18.000000, 0.000000)'>
							<path d='M4.896125,12.9076458 C4.8725625,12.9076458 4.849,12.9046667 4.82597917,12.8984375 C4.75258333,12.8789375 4.69110417,12.8296458 4.65616667,12.7624792 L3.82795833,11.1797292 L2.04316667,11.2539375 C1.9638125,11.2566458 1.89366667,11.2284792 1.8403125,11.1748542 C1.7866875,11.1212292 1.75797917,11.0478333 1.76122917,10.972 L1.83570833,9.18720833 L0.2526875,8.35927083 C0.185791667,8.3240625 0.136229167,8.26258333 0.116729167,8.18945833 C0.0972291667,8.11633333 0.109145833,8.03833333 0.1495,7.97441667 L1.10608333,6.465875 L0.1495,4.95760417 C0.109145833,4.8936875 0.0972291667,4.8156875 0.116729167,4.7425625 C0.136229167,4.6694375 0.185791667,4.6076875 0.2526875,4.57275 L1.83570833,3.7448125 L1.76122917,1.96002083 C1.75797917,1.88445833 1.7866875,1.81079167 1.8403125,1.75716667 C1.89366667,1.70354167 1.96327083,1.675375 2.04316667,1.67808333 L3.82795833,1.75229167 L4.65616667,0.169541667 C4.69110417,0.102375 4.75258333,0.0530833333 4.82597917,0.0335833333 C4.89883333,0.0140833333 4.97710417,0.026 5.04102083,0.066625 L6.5495625,1.02347917 L8.05810417,0.066625 C8.12202083,0.0262708333 8.20029167,0.0140833333 8.27314583,0.0335833333 C8.34654167,0.0530833333 8.40802083,0.102375 8.44295833,0.169541667 L9.27089583,1.75229167 L11.0556875,1.67808333 C11.1358542,1.67564583 11.2051875,1.70354167 11.2585417,1.75716667 C11.3121667,1.81079167 11.340875,1.8841875 11.337625,1.96002083 L11.2634167,3.74454167 L12.8464375,4.57275 C12.9133333,4.60795833 12.9628958,4.6694375 12.9823958,4.7425625 C13.0018958,4.8156875 12.9899792,4.8936875 12.949625,4.95760417 L11.9930417,6.465875 L12.949625,7.97441667 C12.9899792,8.03833333 13.0018958,8.11633333 12.9823958,8.18945833 C12.9628958,8.26258333 12.9133333,8.32433333 12.8464375,8.35927083 L11.2634167,9.18720833 L11.337625,10.972 C11.340875,11.0475625 11.3121667,11.1212292 11.2585417,11.1748542 C11.2051875,11.2284792 11.1353125,11.2561042 11.0556875,11.2539375 L9.27089583,11.1797292 L8.44295833,12.7624792 C8.40802083,12.8296458 8.34654167,12.8789375 8.27314583,12.8984375 C8.20029167,12.9182083 8.12202083,12.9062917 8.05810417,12.8653958 L6.5495625,11.9085417 L5.04102083,12.8653958 C4.99741667,12.8932917 4.94704167,12.9076458 4.896125,12.9076458 Z M3.9885625,10.6310208 C4.08904167,10.6310208 4.18166667,10.6868125 4.22852083,10.7764583 L4.99985417,12.2506042 L6.4049375,11.3595625 C6.49322917,11.3032292 6.6064375,11.3032292 6.69472917,11.3595625 L8.0998125,12.2506042 L8.87114583,10.7764583 C8.919625,10.6835625 9.0098125,10.6280417 9.12247917,10.6312917 L10.7848542,10.7003542 L10.7155208,9.03797917 C10.7109167,8.93316667 10.7675208,8.83539583 10.8604167,8.78664583 L12.3345625,8.01558333 L11.4435208,6.6105 C11.3874583,6.5219375 11.3874583,6.409 11.4435208,6.3204375 L12.3345625,4.915625 L10.8604167,4.14429167 C10.7675208,4.09554167 10.7109167,3.99777083 10.7155208,3.89295833 L10.7848542,2.23085417 L9.12247917,2.29991667 C9.010625,2.30641667 8.919625,2.24764583 8.87114583,2.15475 L8.0998125,0.680604167 L6.69472917,1.57164583 C6.6064375,1.62797917 6.49322917,1.62797917 6.4049375,1.57164583 L4.99985417,0.680604167 L4.22852083,2.15475 C4.18004167,2.24791667 4.08958333,2.30560417 3.9771875,2.29991667 L2.31508333,2.23085417 L2.38441667,3.89295833 C2.38902083,3.99777083 2.33241667,4.09554167 2.23952083,4.14429167 L0.765375,4.915625 L1.65641667,6.3204375 C1.71247917,6.409 1.71247917,6.5219375 1.65641667,6.6105 L0.765375,8.01558333 L2.23952083,8.78664583 C2.33241667,8.83539583 2.38902083,8.93316667 2.38441667,9.03797917 L2.31508333,10.7003542 L3.9771875,10.6312917 C3.98097917,10.6310208 3.98477083,10.6310208 3.9885625,10.6310208 Z M5.40447917,8.89958333 L7.97170833,4.67702083 C8.0494375,4.5491875 8.0088125,4.382625 7.88097917,4.30489583 C7.75314583,4.22689583 7.5863125,4.26779167 7.50885417,4.395625 L4.941625,8.6181875 C4.86389583,8.74602083 4.90452083,8.91258333 5.03235417,8.9903125 C5.07622917,9.017125 5.12497917,9.02985417 5.17291667,9.02985417 C5.2641875,9.02985417 5.3535625,8.98354167 5.40447917,8.89958333 Z M5.14583333,6.5 C4.52210417,6.5 4.01483333,5.99272917 4.01483333,5.36927083 C4.01483333,4.7458125 4.52210417,4.23854167 5.14583333,4.23854167 C5.7695625,4.23854167 6.27683333,4.7458125 6.27683333,5.36927083 C6.27683333,5.99272917 5.7695625,6.5 5.14583333,6.5 Z M5.14583333,4.7799375 C4.82083333,4.7799375 4.5565,5.04427083 4.5565,5.369 C4.5565,5.69372917 4.82083333,5.95833333 5.14583333,5.95833333 C5.47083333,5.95833333 5.73516667,5.694 5.73516667,5.36927083 C5.73516667,5.04454167 5.47083333,4.7799375 5.14583333,4.7799375 Z M7.9535625,8.75279167 C7.32983333,8.75279167 6.8225625,8.24552083 6.8225625,7.6220625 C6.8225625,6.99833333 7.32983333,6.4910625 7.9535625,6.4910625 C8.57702083,6.4910625 9.08429167,6.99833333 9.08429167,7.6220625 C9.08429167,8.24552083 8.57702083,8.75279167 7.9535625,8.75279167 Z M7.9535625,7.03272917 C7.6285625,7.03272917 7.36422917,7.2970625 7.36422917,7.6220625 C7.36422917,7.94679167 7.6285625,8.211125 7.9535625,8.211125 C8.27829167,8.211125 8.542625,7.94679167 8.542625,7.6220625 C8.542625,7.2970625 8.27829167,7.03272917 7.9535625,7.03272917 Z'></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const PromoCodeIcon = ({
	color = OtColors.gray,
	size = '13',
	...props
}) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 14 13' {...props}>
		<g
			stroke='none'
			strokeWidth='1'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g
				transform='translate(-659.000000, -2658.000000)'
				fillRule='nonzero'
				fill={color}
				className='ot_svg_fill'
			>
				<g transform='translate(633.000000, 2655.000000)'>
					<g transform='translate(8.000000, 3.000000)'>
						<g transform='translate(18.000000, 0.000000)'>
							<path
								d='M13.1892 4.51714L9.22203 3.94058L7.44859 0.345269C7.40015 0.246832 7.32046 0.167144 7.22203 0.118707C6.97515 -0.00316804 6.67515 0.0983945 6.55171 0.345269L4.77828 3.94058L0.811089 4.51714C0.701714 4.53277 0.601714 4.58433 0.525151 4.66246C0.432592 4.75759 0.381587 4.88558 0.383345 5.0183C0.385103 5.15102 0.439479 5.27762 0.534526 5.37027L3.40484 8.16871L2.72671 12.1203C2.71081 12.2122 2.72098 12.3067 2.75608 12.3932C2.79117 12.4796 2.84978 12.5545 2.92526 12.6093C3.00074 12.6641 3.09007 12.6967 3.18312 12.7033C3.27617 12.71 3.36922 12.6904 3.45171 12.6468L7.00015 10.7812L10.5486 12.6468C10.6455 12.6984 10.758 12.7156 10.8658 12.6968C11.1377 12.65 11.3205 12.3921 11.2736 12.1203L10.5955 8.16871L13.4658 5.37027C13.5439 5.29371 13.5955 5.19371 13.6111 5.08433C13.6533 4.81089 13.4627 4.55777 13.1892 4.51714Z'
								fill='#F7BF08'
							></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const RenewIcon = ({
	color = OtColors.ot_blue,
	secondaryColor = OtColors.light_blue,
	size = '20',
	...props
}) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 20 20' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-252.000000, -580.000000)' fillRule='nonzero'>
				<g transform='translate(252.000000, 580.000000)'>
					<path
						d='M8.22857143,3.7902439 L8.22857143,4.30243902 C8.22857143,4.66097561 8.43428571,4.96829268 8.74285714,5.17317073 C8.89714286,5.27560976 9.10285714,5.32682927 9.25714286,5.32682927 C9.41142857,5.32682927 9.56571429,5.27560976 9.72,5.22439024 L12.3428571,3.89268293 C12.6514286,3.73902439 12.8571429,3.43170732 12.9085714,3.02195122 C12.96,2.61219512 12.7542857,2.30487805 12.4457143,2.1 L9.82285714,0.307317073 C9.51428571,0.102439024 9.10285714,0.0512195122 8.74285714,0.256097561 C8.38285714,0.409756098 8.17714286,0.768292683 8.17714286,1.17804878 L8.17714286,1.74146341 C3.85714286,2.25365854 0.462857143,5.94146341 0.462857143,10.397561 C0.462857143,12.2926829 1.08,14.0853659 2.21142857,15.6219512 C2.41714286,15.8780488 2.72571429,16.0317073 3.03428571,16.0317073 C3.24,16.0317073 3.44571429,15.9804878 3.65142857,15.8268293 C4.11428571,15.4682927 4.21714286,14.8536585 3.85714286,14.3926829 C2.98285714,13.2146341 2.52,11.8317073 2.52,10.397561 C2.57142857,7.06829268 5.04,4.30243902 8.22857143,3.7902439 Z'
						fill={color}
					></path>
					<path
						d='M18,10.3463415 C18,8.45121951 17.3828571,6.65853659 16.2514286,5.12195122 C15.8914286,4.66097561 15.2742857,4.55853659 14.8114286,4.91707317 C14.3485714,5.27560976 14.2457143,5.8902439 14.6057143,6.35121951 C15.48,7.52926829 15.9428571,8.91219512 15.9428571,10.3463415 C15.9428571,13.6756098 13.4742857,16.4414634 10.2857143,16.902439 L10.2857143,16.4926829 C10.2857143,16.1341463 10.08,15.8268293 9.82285714,15.6219512 C9.51428571,15.4170732 9.15428571,15.4170732 8.84571429,15.5707317 L6.17142857,16.902439 C5.86285714,17.0560976 5.60571429,17.3634146 5.60571429,17.7731707 C5.60571429,18.1829268 5.76,18.4902439 6.06857143,18.695122 L8.69142857,20.4878049 C8.84571429,20.5902439 9.05142857,20.6414634 9.25714286,20.6414634 C9.41142857,20.6414634 9.56571429,20.5902439 9.72,20.5390244 C10.08,20.3853659 10.2857143,20.0268293 10.2857143,19.6170732 L10.2857143,19.0536585 C14.6057143,18.4902439 18,14.802439 18,10.3463415 Z'
						fill={secondaryColor}
					></path>
				</g>
			</g>
		</g>
	</svg>
)

export const SeatCartIcon = ({
	color = OtColors.white,
	size = 18,
	...props
}) => {
	size = parseInt(size)
	let base = 18
	let scale = base / size //1.33
	let dist = size / (4 * scale) - 2
	return (
		<svg
			width={`${size}px`}
			height={`${size}px`}
			viewBox={`0 0 ${size} ${size}`}
			{...props}
		>
			<g
				stroke='none'
				strokeWidth='1'
				fill='none'
				fillRule='evenodd'
				transform={`scale(${scale} ${scale})`}
			>
				<g
					fill={color}
					fillRule='nonzero'
					transform={`translate(${dist} ${dist})`}
				>
					<circle cx='8.5' cy='17.5' r='1.5'></circle>
					<circle cx='14.5' cy='17.5' r='1.5'></circle>
					<path d='M15.8122242,11.4698462 L18.9507249,4.11149279 C19.030961,3.92419858 19.0121689,3.70868196 18.9019497,3.53827843 C18.7910971,3.36787491 18.6029645,3.26524794 18.4017406,3.26524794 L5.61547534,3.26524794 L5.17692139,0.631583449 C5.11611083,0.26683011 4.8044567,0 4.43917103,0 L0.74830775,0 C0.334880387,0 0,0.339096598 0,0.757515287 C0,1.17572017 0.334880387,1.51524438 0.748096602,1.51524438 L3.80636112,1.51524438 L5.94571048,14.3682027 C6.00652104,14.7327423 6.31838632,15 6.68346084,15 L15.8607882,15 C16.2742155,15 16.6090959,14.6606896 16.6090959,14.2424847 C16.6090959,13.824066 16.2742155,13.4847556 15.8607882,13.4847556 L7.31627075,13.4847556 L7.04177863,11.8356686 L15.2626065,11.8356686 C15.5014146,11.8356686 15.7172077,11.6922046 15.8122242,11.4698462 Z'></path>
				</g>
			</g>
		</svg>
	)
}

export const SeatHandicap = ({ color = OtColors.white, size = '18' }) => {
	size = parseInt(size)
	let base = 18
	let scale = size / base //1.33
	let dist = size / (4 * scale) - 1
	return (
		<svg
			width={`${size}px`}
			height={`${size}px`}
			viewBox={`0 0 ${size} ${size}`}
		>
			<g
				stroke='none'
				strokeWidth='1'
				fill='none'
				fillRule='evenodd'
				transform={`scale(${scale} ${scale})`}
			>
				{/*<circle fill="#01BEFF" cx={size/2} cy={size/2} r={size/2} />*/}
				<g
					fill={color}
					fillRule='nonzero'
					transform={`translate(${dist} ${dist})`}
				>
					<path d='M7.17041016,8.95097656 L6.86425781,7.77792969 C6.41308594,8.83066406 5.31738281,9.59765625 4.02832031,9.59765625 C2.33642578,9.59765625 0.966796875,8.31933594 0.966796875,6.74023438 C0.966796875,5.62734375 1.65966797,4.66484375 2.65869141,4.19863281 L2.48144531,3.28125 C1.03125,3.85273438 0,5.19121094 0,6.74023438 C0,8.815625 1.8046875,10.5 4.02832031,10.5 C5.31738281,10.5 6.47753906,9.92851563 7.21875,9.04121094 C7.18652344,9.01113281 7.17041016,8.98105469 7.17041016,8.95097656 Z'></path>
					<path d='M9.80654231,8.35591603 L9.2066836,8.50620229 L8.53367139,5.75596374 C8.47514859,5.48544847 8.24105738,5.30510496 7.96307408,5.30510496 L5.41733224,5.30510496 L5.28565593,4.61378817 L6.96818646,4.61378817 C7.29006187,4.61378817 7.55341447,4.3432729 7.55341447,4.01264313 C7.55341447,3.68201336 7.29006187,3.41149809 6.96818646,3.41149809 L5.06619543,3.41149809 L4.81747353,2.11903626 C5.18324103,1.93869275 5.44659364,1.5629771 5.44659364,1.11211832 C5.44659364,0.495944656 4.96378053,0 4.36392182,0 C3.76406311,0 3.28125,0.495944656 3.28125,1.11211832 C3.28125,1.39766221 3.3836649,1.65314885 3.5446026,1.84852099 L4.33466042,6.02647901 C4.39318322,6.3120229 4.62727442,6.52242366 4.90525773,6.52242366 L7.48026097,6.52242366 L8.18253458,9.39289122 C8.25568808,9.66340649 8.48977929,9.84375 8.75313189,9.84375 C8.79702399,9.84375 8.84091609,9.84375 8.88480819,9.82872137 L10.0552642,9.54317748 C10.3625089,9.46803435 10.5673387,9.13740458 10.4795545,8.82180344 C10.4356624,8.47614504 10.113787,8.2807729 9.80654231,8.35591603 Z'></path>
				</g>
			</g>
		</svg>
	)
}

export const AccessibleSeatingIcon = ({ size = '20' }) => {
	size = Number(size)
	return (
		<svg
			width={`${size}px`}
			height={`${size}px`}
			viewBox={`0 0 ${size} ${size}`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M14.7828 9.40397C14.6294 9.24655 14.415 9.16343 14.1959 9.17543L11.5445 9.32301L13.0037 7.6612C13.2115 7.42448 13.2709 7.10892 13.1906 6.82694C13.1482 6.63372 13.0311 6.45791 12.8514 6.34558C12.8458 6.34164 9.36355 4.31869 9.36355 4.31869C9.0792 4.15351 8.72089 4.1899 8.4755 4.40877L6.77445 5.92615C6.46104 6.20569 6.43359 6.68638 6.71316 6.9998C6.99274 7.31318 7.47345 7.34071 7.78683 7.06107L9.07647 5.91069L10.1426 6.5298L8.26071 8.67309C7.48035 8.80036 6.77822 9.15995 6.22705 9.67841L7.20979 10.6612C7.65404 10.2572 8.24391 10.0107 8.89027 10.0107C10.2689 10.0107 11.3906 11.1323 11.3906 12.511C11.3906 13.1574 11.144 13.7472 10.7401 14.1914L11.7228 15.1742C12.3774 14.4783 12.7792 13.5419 12.7792 12.511C12.7792 11.8968 12.6366 11.316 12.3831 10.7996L13.4094 10.7424L13.1597 13.8048C13.1256 14.2234 13.4373 14.5904 13.8559 14.6245C13.8769 14.6262 13.8978 14.627 13.9185 14.627C14.3105 14.627 14.6432 14.3259 14.6756 13.9284L14.996 9.99651C15.0139 9.77742 14.9362 9.56136 14.7828 9.40397Z'
				fill='white'
			></path>
			<path
				d='M13.3729 6.14659C14.0758 6.14659 14.6455 5.57678 14.6455 4.87384C14.6455 4.17094 14.0758 3.60107 13.3729 3.60107C12.6699 3.60107 12.1001 4.17094 12.1001 4.87384C12.1001 5.57678 12.6699 6.14659 13.3729 6.14659Z'
				fill='white'
			></path>
			<path
				d='M8.88999 15.0102C7.51146 15.0102 6.38993 13.8887 6.38993 12.5101C6.38993 11.9906 6.54933 11.5077 6.82162 11.1075L5.82839 10.1143C5.31086 10.7747 5.00146 11.6061 5.00146 12.5101C5.00146 14.6577 6.7424 16.3986 8.88999 16.3986C9.79408 16.3986 10.6254 16.0892 11.2858 15.5717L10.2926 14.5785C9.89237 14.8507 9.40948 15.0102 8.88999 15.0102Z'
				fill='white'
			></path>
		</svg>
	)
}

export const CompanionSeatingIcon = ({ size = '10' }) => {
	size = Number(size)
	return (
		<svg
			width={`${size}px`}
			height={`${size}px`}
			viewBox={`0 0 ${size} ${size}`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			style={{ marginRight: '9px' }}
		>
			<path
				d='M5.05185 0C6.35555 0 7.43704 0.315252 8.2963 0.945759C9.15555 1.57626 9.72346 2.43394 10 3.51877H7.80741C7.58025 2.99026 7.22469 2.57301 6.74074 2.26704C6.26666 1.96106 5.69382 1.80806 5.02222 1.80806C4.46914 1.80806 3.97038 1.93788 3.52592 2.1975C3.08149 2.45711 2.7358 2.828 2.48889 3.31015C2.24198 3.7923 2.11851 4.3579 2.11851 5.00695C2.11851 5.64674 2.24198 6.2077 2.48889 6.68985C2.7358 7.172 3.08149 7.54289 3.52592 7.8025C3.97038 8.06213 4.46914 8.19194 5.02222 8.19194C5.69382 8.19194 6.26666 8.03894 6.74074 7.73296C7.22469 7.42699 7.58025 7.00974 7.80741 6.48123H10C9.72346 7.56606 9.15555 8.42374 8.2963 9.05424C7.43704 9.68475 6.35555 10 5.05185 10C4.05433 10 3.17037 9.79138 2.4 9.37414C1.6395 8.94761 1.04691 8.3542 0.622222 7.59387C0.207408 6.83356 0 5.97126 0 5.00695C0 4.03337 0.207408 3.16644 0.622222 2.40613C1.04691 1.6458 1.6395 1.05702 2.4 0.639777C3.1605 0.213259 4.04445 0 5.05185 0Z'
				fill='white'
			></path>
		</svg>
	)
}

export const SeatSelectedIcon = ({ size = '18' }) => {
	size = parseInt(size)
	let base = 18
	let scale = size / base //1.33
	let distX = size / (4 * scale) - 1
	let distY = (size * 1.2) / (4 * scale)
	return (
		<svg
			width={`${size}px`}
			height={`${size * 0.8}px`}
			viewBox={`0 0 ${size} ${size * 0.8}`}
		>
			<g
				stroke='none'
				strokeWidth='1'
				fill='none'
				fillRule='evenodd'
				transform={`scale(${scale} ${scale})`}
			>
				<g transform={`translate(${distX} ${distY})`}>
					<g transform='translate(-365.000000, -469.000000)' fill='#FFFFFF'>
						<polygon points='368.116579 477 365 474.113179 366.11835 473.077064 368.06218 474.877958 373.829781 469 375 469.985129'></polygon>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const SeatHandicapCompanion = ({ x, y, size = '10', ...props }) => (
	<svg
		width={`${size}px`}
		height={`${size}px`}
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 48 48'
		{...props}
	>
		<path
			d='M4.04148 0C5.08444 0 5.94963 0.252202 6.63704 0.756607C7.32444 1.26101 7.77877 1.94715 8 2.81502H6.24593C6.0642 2.39221 5.77975 2.05841 5.39259 1.81363C5.01333 1.56885 4.55506 1.44645 4.01778 1.44645C3.57531 1.44645 3.1763 1.5503 2.82074 1.758C2.46519 1.96569 2.18864 2.2624 1.99111 2.64812C1.79358 3.03384 1.69481 3.48632 1.69481 4.00556C1.69481 4.51739 1.79358 4.96616 1.99111 5.35188C2.18864 5.7376 2.46519 6.03431 2.82074 6.242C3.1763 6.4497 3.57531 6.55355 4.01778 6.55355C4.55506 6.55355 5.01333 6.43115 5.39259 6.18637C5.77975 5.94159 6.0642 5.60779 6.24593 5.18498H8C7.77877 6.05285 7.32444 6.73899 6.63704 7.24339C5.94963 7.7478 5.08444 8 4.04148 8C3.24346 8 2.5363 7.8331 1.92 7.49931C1.3116 7.15809 0.837531 6.68336 0.497778 6.0751C0.165926 5.46685 0 4.77701 0 4.00556C0 3.2267 0.165926 2.53315 0.497778 1.9249C0.837531 1.31664 1.3116 0.845619 1.92 0.511822C2.5284 0.170607 3.23556 0 4.04148 0Z'
			fill='#17ACCD'
			transform={`translate(${x} ${y})`}
		></path>
	</svg>
)

export const SeatHandicapCompanionSelected = ({
	x,
	y,
	size = '10',
	...props
}) => (
	<svg
		width={`${size}px`}
		height={`${size}px`}
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 48 48'
		{...props}
	>
		<path
			d='M4.04148 0C5.08444 0 5.94963 0.252202 6.63704 0.756607C7.32444 1.26101 7.77877 1.94715 8 2.81502H6.24593C6.0642 2.39221 5.77975 2.05841 5.39259 1.81363C5.01333 1.56885 4.55506 1.44645 4.01778 1.44645C3.57531 1.44645 3.1763 1.5503 2.82074 1.758C2.46519 1.96569 2.18864 2.2624 1.99111 2.64812C1.79358 3.03384 1.69481 3.48632 1.69481 4.00556C1.69481 4.51739 1.79358 4.96616 1.99111 5.35188C2.18864 5.7376 2.46519 6.03431 2.82074 6.242C3.1763 6.4497 3.57531 6.55355 4.01778 6.55355C4.55506 6.55355 5.01333 6.43115 5.39259 6.18637C5.77975 5.94159 6.0642 5.60779 6.24593 5.18498H8C7.77877 6.05285 7.32444 6.73899 6.63704 7.24339C5.94963 7.7478 5.08444 8 4.04148 8C3.24346 8 2.5363 7.8331 1.92 7.49931C1.3116 7.15809 0.837531 6.68336 0.497778 6.0751C0.165926 5.46685 0 4.77701 0 4.00556C0 3.2267 0.165926 2.53315 0.497778 1.9249C0.837531 1.31664 1.3116 0.845619 1.92 0.511822C2.5284 0.170607 3.23556 0 4.04148 0Z'
			fill='white'
			transform={`translate(${x} ${y})`}
		></path>
	</svg>
)

export const SeatUserIcon = ({
	color = OtColors.white,
	x,
	y,
	size = '10',
	...props
}) => {
	let wSize = parseInt(size) * 0.8
	return (
		<svg
			width={`${wSize}px`}
			height={`${size}px`}
			viewBox={'0 0 8 10'}
			{...props}
		>
			<g
				stroke='none'
				strokeWidth='1'
				fill='none'
				fillRule='evenodd'
				transform={`translate(${x} ${y})`}
			>
				<g transform='translate(-184.000000, -213.000000)'>
					<g transform='translate(184.000000, 213.000000)' fill={color}>
						<path d='M0,10 C0,7.699 1.449,6.25 3.75,6.25 C6.051,6.25 7.5,7.699 7.5,10 L0,10 Z'></path>
						<path d='M6.25,2.5 C6.25,3.881 5.131,5 3.75,5 C2.369,5 1.25,3.881 1.25,2.5 C1.25,1.119 2.369,0 3.75,0 C5.131,0 6.25,1.119 6.25,2.5'></path>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const SelectedCircleIcon = ({
	bgdColor,
	color = OtColors.gray,
	size = '19',
	...props
}) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 19 19' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g transform='translate(-930.000000, -507.000000)'>
				<g transform='translate(930.000000, 507.000000)'>
					<circle
						className='ot_svg_bgdFill'
						fill={bgdColor}
						cx='9.5'
						cy='9.5'
						r='9.5'
					></circle>
					<g
						transform='translate(6.000000, 7.000000)'
						fillRule='nonzero'
						fill={color}
						className='ot_svg_fill'
					>
						<path d='M6.36880138,0.0885821092 C6.25666951,-0.0295273697 6.0727557,-0.0295273697 5.96055074,0.0885821092 L2.33951009,3.90040203 C2.22730512,4.01851151 2.04346441,4.01851151 1.93125945,3.90040203 L1.03939444,2.96168175 C0.927189472,2.84357227 0.743348762,2.84357227 0.631143796,2.96168175 L0.0841537245,3.53776361 C-0.0280512415,3.65587309 -0.0280512415,3.84938797 0.0841537245,3.96749745 L1.93125945,5.91141789 C2.04346441,6.02952737 2.22730512,6.02952737 2.33951009,5.91141789 L6.91579145,1.09409004 C7.02806952,0.975903614 7.02806952,0.78246568 6.91579145,0.664279256 L6.36880138,0.0885821092 Z'></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const ClockIcon = ({ size = '14' }) => (
	<svg
		width={`${size}px`}
		height={`${size}px`}
		viewBox='0 0 14 14'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.5 2.99886C6.5 2.90681 6.57462 2.83219 6.66667 2.83219H7.33333C7.42538 2.83219 7.5 2.90681 7.5 2.99886V7.07991L9.44628 9.02619C9.51137 9.09127 9.51137 9.1968 9.44628 9.26189L8.97487 9.73329C8.90979 9.79838 8.80426 9.79838 8.73917 9.73329L6.5029 7.49702H6.5V2.99886Z'
			fill='#868E96'
		></path>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM12.6667 7C12.6667 10.1296 10.1296 12.6667 7 12.6667C3.87039 12.6667 1.33333 10.1296 1.33333 7C1.33333 3.87039 3.87039 1.33333 7 1.33333C10.1296 1.33333 12.6667 3.87039 12.6667 7Z'
			fill='#868E96'
		></path>
	</svg>
)

export const LocationIcon = ({ width = '12', height = '14' }) => (
	<svg
		width={`${width}px`}
		height={`${height}px`}
		viewBox='0 0 12 14'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M11.3531 3.51719C11.059 2.83888 10.6348 2.22472 10.1047 1.70937C9.5728 1.18937 8.94576 0.776654 8.25781 0.49375C7.54219 0.196875 6.78281 0.046875 6 0.046875C5.21719 0.046875 4.45781 0.196875 3.74219 0.492188C3.05 0.778125 2.42969 1.1875 1.89531 1.70781C1.3655 2.22345 0.941431 2.83753 0.646875 3.51562C0.342187 4.21875 0.1875 4.96562 0.1875 5.73438C0.1875 6.8375 0.451563 7.93594 0.970313 8.99531C1.3875 9.84688 1.97031 10.6766 2.70469 11.4656C3.95938 12.8125 5.275 13.6359 5.64844 13.8562C5.75444 13.9189 5.87533 13.9518 5.99844 13.9516C6.12031 13.9516 6.24062 13.9203 6.34844 13.8562C6.72187 13.6359 8.0375 12.8125 9.29219 11.4656C10.0266 10.6781 10.6094 9.84688 11.0266 8.99531C11.5484 7.9375 11.8125 6.84062 11.8125 5.73594C11.8125 4.96719 11.6578 4.22031 11.3531 3.51719ZM6 12.7531C4.97031 12.0984 1.3125 9.50625 1.3125 5.73594C1.3125 4.51875 1.79844 3.375 2.68125 2.5125C3.56719 1.64844 4.74531 1.17188 6 1.17188C7.25469 1.17188 8.43281 1.64844 9.31875 2.51406C10.2016 3.375 10.6875 4.51875 10.6875 5.73594C10.6875 9.50625 7.02969 12.0984 6 12.7531ZM6 3.10938C4.48125 3.10938 3.25 4.34062 3.25 5.85938C3.25 7.37813 4.48125 8.60938 6 8.60938C7.51875 8.60938 8.75 7.37813 8.75 5.85938C8.75 4.34062 7.51875 3.10938 6 3.10938ZM7.2375 7.09688C7.07519 7.25965 6.8823 7.38873 6.66992 7.47668C6.45754 7.56464 6.22987 7.60973 6 7.60938C5.53281 7.60938 5.09375 7.42656 4.7625 7.09688C4.59972 6.93457 4.47065 6.74167 4.38269 6.5293C4.29474 6.31692 4.24964 6.08924 4.25 5.85938C4.25 5.39219 4.43281 4.95312 4.7625 4.62187C5.09375 4.29062 5.53281 4.10938 6 4.10938C6.46719 4.10938 6.90625 4.29062 7.2375 4.62187C7.56875 4.95312 7.75 5.39219 7.75 5.85938C7.75 6.32656 7.56875 6.76562 7.2375 7.09688Z'
			fill='#868E96'
		></path>
	</svg>
)

export const ShowBarDownArrowIcon = ({
	width = '12',
	height = '6',
	fill = '#343A40',
}) => (
	<svg
		width={`${width}px`}
		height={`${height}px`}
		viewBox='0 0 12 6'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.01003 4.62493L10.4872 0.0446632L11.2735 0.818619L6.41741 5.80384C6.21688 6.01009 5.80319 6.01009 5.60108 5.80384L0.726593 0.826292L1.52953 0.0413513L6.01003 4.62493Z'
			fill={fill}
		></path>
	</svg>
)

export const PromoAppliedCheckIcon = ({ size = '16' }) => (
	<svg
		width={`${size}px`}
		height={`${size}px`}
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M10.9218 5.51562H10.189C10.0297 5.51562 9.8781 5.59219 9.78435 5.72344L7.32809 9.12969L6.21558 7.58594C6.12183 7.45625 5.97183 7.37813 5.81089 7.37813H5.07808C4.97652 7.37813 4.91714 7.49375 4.97652 7.57656L6.9234 10.2766C6.96939 10.3408 7.03002 10.3931 7.10026 10.4291C7.17051 10.4652 7.24834 10.4841 7.32731 10.4841C7.40627 10.4841 7.48411 10.4652 7.55435 10.4291C7.62459 10.3931 7.68522 10.3408 7.73121 10.2766L11.0218 5.71406C11.0828 5.63125 11.0234 5.51562 10.9218 5.51562Z'
			fill='#343A40'
		></path>
		<path
			d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 8C2.1875 4.79063 4.79063 2.1875 8 2.1875C11.2094 2.1875 13.8125 4.79063 13.8125 8C13.8125 11.2094 11.2094 13.8125 8 13.8125Z'
			fill='#343A40'
		></path>
	</svg>
)

export const TicketIcon = ({
	color = OtColors.gray,
	size = '13',
	...props
}) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 13 13' {...props}>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g fillRule='nonzero' fill={color ? color : ''} className='ot_svg_fill'>
				<path d='M10.4722222,3.61111111 C9.87393333,3.61111111 9.38888889,3.12606667 9.38888889,2.52777778 C9.38888889,2.22863333 9.51007778,1.9578 9.70623333,1.76178889 L7.94444444,0 L0,7.94444444 L1.76178889,9.70623333 C1.9578,9.51007778 2.22863333,9.38888889 2.52777778,9.38888889 C3.12606667,9.38888889 3.61111111,9.87393333 3.61111111,10.4722222 C3.61111111,10.7713667 3.48992222,11.0422 3.29376667,11.2382111 L5.05555556,13 L13,5.05555556 L11.2382111,3.29376667 C11.0422,3.48992222 10.7713667,3.61111111 10.4722222,3.61111111 Z M9.96146667,6.56196667 L9.47642222,6.07692222 L8.96581111,6.58753333 L9.45085556,7.07257778 L5.05555556,11.4678778 L4.62135556,11.0336778 C4.6696,10.8526889 4.69444444,10.6643333 4.69444444,10.4720778 C4.69444444,9.27737778 3.72247778,8.30541111 2.52777778,8.30541111 C2.33552222,8.30541111 2.14716667,8.33025556 1.96617778,8.3785 L1.53212222,7.94444444 L5.92742222,3.54914444 L6.41246667,4.03418889 L6.92307778,3.52357778 L6.43803333,3.03853333 L7.94444444,1.53212222 L8.37864444,1.96632222 C8.3304,2.14716667 8.30555556,2.33552222 8.30555556,2.52777778 C8.30555556,3.72247778 9.27752222,4.69444444 10.4722222,4.69444444 C10.6644778,4.69444444 10.8528333,4.6696 11.0338222,4.62135556 L11.4678778,5.05555556 L9.96146667,6.56196667 Z'></path>
				<rect
					transform='translate(8.455230, 5.369887) rotate(-135.000000) translate(-8.455230, -5.369887) '
					x='7.95522991'
					y='4.86988707'
					width='1'
					height='1'
				></rect>
				<rect
					transform='translate(7.630185, 4.544901) rotate(-45.000000) translate(-7.630185, -4.544901) '
					x='7.13018499'
					y='4.04490111'
					width='1'
					height='1'
				></rect>
			</g>
		</g>
	</svg>
)

export const TrashIcon = ({ color = OtColors.gray, size = '20', ...props }) => (
	<svg
		width={`${parseInt(size) * 0.75}px`}
		height={`${size}px`}
		viewBox={'0 0 18 24'}
		{...props}
	>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g fillRule='nonzero' fill={color} className='ot_svg_fill trash'>
				<path d='M17.996,6.451 C17.996,5.752 17.43,5.185 16.73,5.185 L13.787,5.185 C13.594,2.702 11.533,0.733 9,0.733 C6.467,0.733 4.406,2.702 4.213,5.185 L1.27,5.185 C0.571,5.185 0.003,5.751 0.003,6.451 C0.003,7.123 0.531,7.66 1.192,7.702 L1.192,22 C1.192,22.699 1.759,23.267 2.459,23.267 L11.537,23.267 L15.541,23.267 C16.24,23.267 16.807,22.7 16.807,22 L16.807,7.702 C17.469,7.661 17.996,7.124 17.996,6.451 Z M9,3.266 C10.136,3.266 11.076,4.1 11.255,5.186 L6.744,5.186 C6.924,4.1 7.864,3.266 9,3.266 Z M11.537,20.733 L3.725,20.733 L3.725,7.718 L14.275,7.718 L14.275,20.734 L11.537,20.734 L11.537,20.733 Z'></path>
				<path d='M6.914,10.086 C6.215,10.086 5.647,10.652 5.647,11.352 L5.647,17.288 C5.647,17.987 6.214,18.555 6.914,18.555 C7.614,18.555 8.18,17.988 8.18,17.288 L8.18,11.352 C8.179,10.652 7.613,10.086 6.914,10.086 Z'></path>
				<path d='M11.053,10.086 C10.354,10.086 9.787,10.652 9.787,11.352 L9.787,17.288 C9.787,17.987 10.354,18.555 11.053,18.555 C11.752,18.555 12.319,17.988 12.319,17.288 L12.319,11.352 C12.318,10.652 11.752,10.086 11.053,10.086 Z'></path>
			</g>
		</g>
	</svg>
)

export const TwitterIcon = ({ color = OtColors.gray, size = '14' }) => {
	let width = parseInt(size) * 1.22
	return (
		<svg width={`${width}px`} height={`${size}px`} viewBox='0 0 22 18'>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g
					transform='translate(-49.000000, -2.000000)'
					fill={color}
					fillRule='nonzero'
					className='ot_svg_fill'
				>
					<path d='M71,4.13 C70.19,4.49 69.32,4.74 68.41,4.85 C69.34,4.29 70.06,3.4 70.4,2.34 C69.53,2.86 68.56,3.24 67.53,3.44 C66.71,2.56 65.53,2 64.24,2 C61.75,2 59.72,4.04 59.72,6.54 C59.72,6.9 59.76,7.24 59.84,7.58 C56.09,7.39 52.76,5.58 50.53,2.83 C50.14,3.5 49.92,4.28 49.92,5.11 C49.92,6.69 50.96,8.08 52.17,8.89 C51.43,8.87 50.37,8.66 50.37,8.32 L50.37,8.38 C50.37,10.58 51.68,12.42 53.75,12.84 C53.37,12.94 52.85,13 52.44,13 C52.15,13 51.81,12.97 51.53,12.92 C52.1,14.73 53.74,16.04 55.72,16.08 C54.18,17.3 52.21,18.02 50.1,18.02 C49.73,18.02 49.37,18 49.01,17.96 C51.01,19.25 53.38,20 55.93,20 C64.24,20 68.77,13.08 68.77,7.07 C68.77,6.87 68.76,6.68 68.76,6.48 C69.63,5.84 70.4,5.04 71,4.13 Z'></path>
				</g>
			</g>
		</svg>
	)
}

export const UserIcon = ({ color = OtColors.black, size = '24' }) => (
	<svg
		width={`${parseInt(size) * 0.91}px`}
		height={`${size}px`}
		viewBox='0 0 22 24'
	>
		<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g
				transform='translate(-796.000000, -177.000000)'
				fillRule='nonzero'
				fill={color}
				className='ot_svg_fill'
			>
				<g transform='translate(796.000000, 177.000000)'>
					<path d='M15.9278373,12.9075835 C17.3298575,11.544072 18.2130477,9.61293932 18.2130477,7.46818575 C18.2130477,3.3495753 14.977435,0 10.9977729,0 C7.02046911,0 3.78485641,3.3495753 3.78485641,7.46818575 C3.78485641,8.7486903 4.10676685,10.0194293 4.72228793,11.1436855 C4.81897898,11.3194649 4.92392414,11.4879202 5.04419837,11.6746859 C5.34606312,12.1300036 5.69273591,12.5389349 6.07242515,12.9088042 C2.71064242,14.6641575 0.299261966,18.1504501 0.00447217956,22.255633 C-0.0285442766,22.7060679 0.122388094,23.1491786 0.419536199,23.4812064 C0.715505145,23.8120136 1.13174832,24 1.56921637,24 L20.4310461,24 C20.867335,24 21.2835782,23.8120136 21.5807263,23.4812064 C21.8778744,23.1503993 22.0276276,22.7060679 21.9957903,22.255633 C21.6998213,18.1492294 19.2884409,14.6641575 15.9278373,12.9075835 Z M9.19248026,11.2462235 C9.08399761,11.1876303 8.97787329,11.1290372 8.87056981,11.0606785 C8.3800396,10.7494024 7.96261726,10.3368089 7.64070682,9.8521947 C7.5746739,9.75087737 7.50982015,9.64833935 7.45204135,9.54458064 C7.09947277,8.90005595 6.9225989,8.20060017 6.9225989,7.46940644 C6.9225989,5.14154926 8.75147473,3.24825797 10.9989521,3.24825797 C13.2487877,3.24825797 15.0764844,5.14154926 15.0764844,7.46940644 C15.0764844,9.79360155 13.2523252,11.6844515 11.006027,11.6893342 C11.0048479,11.6893342 11.0024895,11.6893342 11.0001312,11.6893342 C10.9977729,11.6893342 10.9942354,11.6893342 10.9918771,11.6893342 C10.361027,11.6881135 9.74786421,11.5355272 9.19248026,11.2462235 Z M3.44643773,20.751742 C4.43221478,17.3838564 7.47208706,14.9400336 10.990698,14.9363715 C10.9930563,14.9363715 10.9954146,14.9363715 10.9977729,14.9363715 C11.0013104,14.9363715 11.0048479,14.9363715 11.0083853,14.9363715 C14.5281754,14.9400336 17.5692268,17.3826357 18.5538247,20.751742 L3.44643773,20.751742 Z'></path>
				</g>
			</g>
		</g>
	</svg>
)

export const CalendarViewIcon = ({ color, size = 25 }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 25 25'>
		<g fill={color} fillRule='evenodd'>
			<g fill={color}>
				<path d='M20,2 L17,2 L17,0 L15,0 L15,6 L17,6 L17,4 L20,4 L20,19 L2,19 L2,4 L4,4 L4,2 L2,2 C0.896,2 0,2.896 0,4 L0,19 C0,20.104 0.896,21 2,21 L20,21 C21.104,21 22,20.104 22,19 L22,4 C22,2.896 21.104,2 20,2'></path>
				<polygon points='7 4 14 4 14 2 7 2 7 0 5 0 5 6 7 6'></polygon>
				<polygon points='8 8 4 8 4 12 8 12'></polygon>
				<polygon points='13 8 9 8 9 12 13 12'></polygon>
				<polygon points='14 12 18 12 18 8 14 8'></polygon>
				<polygon points='4 17 8 17 8 13 4 13'></polygon>
				<polygon points='9 17 13 17 13 13 9 13'></polygon>
			</g>
		</g>
	</svg>
)

export const ListViewIcon = ({ color, size = 25 }) => (
	<svg width={`${size}px`} height={`${size}px`} viewBox='0 0 25 25'>
		<g fill={color} fillRule='evenodd'>
			<g fill={color}>
				<path d='M2,2 L2,7 L6.997,7 L7,2 L2,2 Z M7,9 L2,9 C0.897,9 0,8.103 0,7 L0,2 C0,0.897 0.897,0 2,0 L7,0 C8.103,0 9,0.897 9,2 L9,7 C9,8.103 8.103,9 7,9 L7,9 Z'></path>
				<path d='M2,13 L2,18 L6.997,18 L7,13 L2,13 Z M7,20 L2,20 C0.897,20 0,19.103 0,18 L0,13 C0,11.897 0.897,11 2,11 L7,11 C8.103,11 9,11.897 9,13 L9,18 C9,19.103 8.103,20 7,20 L7,20 Z'></path>
				<polygon points='20 4 10 4 10 2 20 2'></polygon>
				<polygon points='20 7 10 7 10 5 20 5'></polygon>
				<polygon points='20 15 10 15 10 13 20 13'></polygon>
				<polygon points='20 18 10 18 10 16 20 16'></polygon>
			</g>
		</g>
	</svg>
)

export const WarningIcon = ({ size = '80' }) => {
	let base = 80
	let scaleFactor = parseInt(size) / base
	return (
		<svg
			width={`${size}px`}
			height={`${size}px`}
			viewBox={`0 0 ${size} ${size}`}
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g transform={`scale(${scaleFactor} ${scaleFactor})`}>
					<circle fill='#FADEC8' cx='40' cy='40' r='40'></circle>
					<g
						transform='translate(40.000000, 40.000000) rotate(-180.000000) translate(-40.000000, -40.000000) translate(35.000000, 23.000000)'
						fill='#FFA27B'
					>
						<polygon points='10 34 0 34 0 14 10 14'></polygon>
						<path d='M10,5 C10,7.765 7.76,10 5,10 C2.24,10 0,7.765 0,5 C0,2.24 2.24,0 5,0 C7.76,0 10,2.24 10,5'></path>
					</g>
				</g>
			</g>
		</svg>
	)
}

export const WarningNoBackgroundIcon = ({ size = 25 }) => (
	<svg
		width={`${size}px`}
		height={`${size}px`}
		viewBox={`0 0 ${size} ${size}`}
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle cx='12' cy='12.7417' r='11' stroke='#FF3200' strokeWidth='2' />
		<line
			x1='12'
			y1='7.7417'
			x2='12'
			y2='13.7417'
			stroke='#FF3200'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<circle cx='12' cy='17.7417' r='1' fill='#FF3200' />
	</svg>
)

export const SvgChevron = () => {
	return (
		<svg
			width='12'
			height='6'
			viewBox='0 0 12 6'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M6.01 4.62492L10.4872 0.0446556L11.2735 0.818612L6.41738 5.80383C6.21685 6.01008 5.80316 6.01008 5.60105 5.80383L0.726562 0.826284L1.5295 0.0413437L6.01 4.62492Z'
				fill='#868E96'
			></path>
		</svg>
	)
}

export const SvgClose = () => {
	return (
		<svg
			width='10'
			height='12'
			viewBox='0 0 10 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M5.80926 6L9.91082 1.11094C9.97957 1.02969 9.92176 0.90625 9.81551 0.90625H8.56863C8.49519 0.90625 8.42488 0.939062 8.37644 0.995312L4.99363 5.02813L1.61082 0.995312C1.56394 0.939062 1.49363 0.90625 1.41863 0.90625H0.171756C0.0655061 0.90625 0.00769351 1.02969 0.0764435 1.11094L4.17801 6L0.0764435 10.8891C0.0610429 10.9072 0.0511628 10.9293 0.0479759 10.9529C0.0447889 10.9764 0.048429 11.0004 0.0584644 11.022C0.0684997 11.0435 0.0845088 11.0617 0.10459 11.0745C0.124672 11.0872 0.147983 11.0939 0.171756 11.0938H1.41863C1.49207 11.0938 1.56238 11.0609 1.61082 11.0047L4.99363 6.97188L8.37644 11.0047C8.42332 11.0609 8.49363 11.0938 8.56863 11.0938H9.81551C9.92176 11.0938 9.97957 10.9703 9.91082 10.8891L5.80926 6Z'
				fill='#495057'
			></path>
		</svg>
	)
}

export const SvgWheelchair = () => {
	return (
		<svg
			width='10'
			height='14'
			viewBox='0 0 10 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M9.78257 6.40405C9.62914 6.24663 9.41476 6.16351 9.1957 6.17551L6.54429 6.3231L8.00342 4.66128C8.21129 4.42456 8.27068 4.109 8.19032 3.82702C8.14791 3.6338 8.03089 3.45799 7.85113 3.34566C7.8456 3.34173 4.36331 1.31878 4.36331 1.31878C4.07895 1.15359 3.72065 1.18999 3.47526 1.40886L1.7742 2.92623C1.4608 3.20577 1.43335 3.68646 1.71291 3.99988C1.9925 4.31327 2.4732 4.34079 2.78659 4.06115L4.07622 2.91077L5.14235 3.52988L3.26046 5.67317C2.48011 5.80044 1.77798 6.16003 1.22681 6.67849L2.20955 7.66123C2.6538 7.25729 3.24366 7.01074 3.89002 7.01074C5.26869 7.01074 6.39033 8.1324 6.39033 9.51109C6.39033 10.1574 6.14378 10.7473 5.73988 11.1915L6.72256 12.1743C7.37719 11.4784 7.77895 10.542 7.77895 9.51109C7.77895 8.89692 7.63637 8.31612 7.38285 7.79966L8.40915 7.74249L8.15948 10.8049C8.12535 11.2235 8.43707 11.5904 8.85567 11.6246C8.87663 11.6263 8.89755 11.6271 8.91827 11.6271C9.31022 11.6271 9.64298 11.326 9.67535 10.9284L9.9958 6.99659C10.0137 6.7775 9.93592 6.56144 9.78257 6.40405Z'
				fill='white'
			></path>
			<path
				d='M8.37238 3.14659C9.07527 3.14659 9.64503 2.57678 9.64503 1.87384C9.64503 1.17094 9.07527 0.601074 8.37238 0.601074C7.6694 0.601074 7.09961 1.17094 7.09961 1.87384C7.09961 2.57678 7.66938 3.14659 8.37238 3.14659Z'
				fill='white'
			></path>
			<path
				d='M3.88975 12.0103C2.51122 12.0103 1.38968 10.8887 1.38968 9.5102C1.38968 8.99067 1.54909 8.50779 1.82138 8.10755L0.828144 7.11434C0.310612 7.77477 0.0012207 8.60615 0.0012207 9.5102C0.0012207 11.6578 1.74215 13.3987 3.88975 13.3987C4.79384 13.3987 5.62514 13.0893 6.28555 12.5718L5.29234 11.5786C4.89212 11.8508 4.40924 12.0103 3.88975 12.0103Z'
				fill='white'
			></path>
		</svg>
	)
}

export const SvgCompanion = () => {
	return (
		<svg
			width='10'
			height='10'
			viewBox='0 0 10 10'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M5.05185 0C6.35555 0 7.43704 0.315252 8.2963 0.945759C9.15555 1.57626 9.72346 2.43394 10 3.51877H7.80741C7.58025 2.99026 7.22469 2.57301 6.74074 2.26704C6.26666 1.96106 5.69382 1.80806 5.02222 1.80806C4.46914 1.80806 3.97038 1.93788 3.52592 2.1975C3.08149 2.45711 2.7358 2.828 2.48889 3.31015C2.24198 3.7923 2.11851 4.3579 2.11851 5.00695C2.11851 5.64674 2.24198 6.2077 2.48889 6.68985C2.7358 7.172 3.08149 7.54289 3.52592 7.8025C3.97038 8.06213 4.46914 8.19194 5.02222 8.19194C5.69382 8.19194 6.26666 8.03894 6.74074 7.73296C7.22469 7.42699 7.58025 7.00974 7.80741 6.48123H10C9.72346 7.56606 9.15555 8.42374 8.2963 9.05424C7.43704 9.68475 6.35555 10 5.05185 10C4.05433 10 3.17037 9.79138 2.4 9.37414C1.6395 8.94761 1.04691 8.3542 0.622222 7.59387C0.207408 6.83356 0 5.97126 0 5.00695C0 4.03337 0.207408 3.16644 0.622222 2.40613C1.04691 1.6458 1.6395 1.05702 2.4 0.639777C3.1605 0.213259 4.04445 0 5.05185 0Z'
				fill='white'
			></path>
		</svg>
	)
}

export const SvgWheelchairNoColor = () => {
	return (
		<svg
			width='12'
			height='16'
			viewBox='0 0 12 16'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M11.7387 7.28486C11.5546 7.09595 11.2974 6.99622 11.0345 7.01061L7.85281 7.18771L9.60377 5.19354C9.85321 4.90947 9.92447 4.5308 9.82804 4.19242C9.77715 3.96056 9.63673 3.74959 9.42101 3.6148C9.41438 3.61007 5.23562 1.18253 5.23562 1.18253C4.8944 0.984311 4.46443 1.02798 4.16996 1.29063L2.1287 3.11147C1.75261 3.44693 1.71967 4.02375 2.05515 4.39986C2.39065 4.77592 2.9675 4.80895 3.34356 4.47338L4.89112 3.09293L6.17048 3.83586L3.91221 6.40781C2.97579 6.56053 2.13323 6.99204 1.47182 7.61419L2.65111 8.79348C3.18422 8.30875 3.89205 8.01288 4.66769 8.01288C6.32209 8.01288 7.66806 9.35888 7.66806 11.0133C7.66806 11.7889 7.37219 12.4967 6.88751 13.0298L8.06673 14.2091C8.85228 13.374 9.3344 12.2503 9.3344 11.0133C9.3344 10.2763 9.1633 9.57935 8.85908 8.95959L10.0906 8.89099L9.79104 12.5659C9.75007 13.0682 10.1241 13.5085 10.6265 13.5495C10.6516 13.5516 10.6767 13.5526 10.7016 13.5526C11.1719 13.5526 11.5712 13.1911 11.6101 12.7141L11.9946 7.9959C12.0161 7.733 11.9228 7.47373 11.7387 7.28486Z'></path>
			<path d='M10.0465 3.37591C10.89 3.37591 11.5737 2.69214 11.5737 1.84861C11.5737 1.00513 10.89 0.321289 10.0465 0.321289C9.20294 0.321289 8.51919 1.00513 8.51919 1.84861C8.51919 2.69214 9.20291 3.37591 10.0465 3.37591Z'></path>
			<path d='M4.66735 14.0123C3.01312 14.0123 1.66728 12.6665 1.66728 11.0122C1.66728 10.3888 1.85856 9.80935 2.18531 9.32906L0.993429 8.13721C0.372391 8.92973 0.00112152 9.92738 0.00112152 11.0122C0.00112152 13.5894 2.09024 15.6785 4.66735 15.6785C5.75226 15.6785 6.74982 15.3072 7.54232 14.6861L6.35046 13.4943C5.8702 13.821 5.29074 14.0123 4.66735 14.0123Z'></path>
		</svg>
	)
}

export const CompanionNoColor = ({ color = OtColors.black, width = '12', height = '12' }) => {
	return (
		<svg
			width={`${width}px`}
			height={`${height}px`}
			viewBox='0 0 12 12'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M6.06222 0C7.62666 0 8.92445 0.378303 9.95556 1.13491C10.9867 1.89152 11.6682 2.92073 12 4.22253H9.3689C9.0963 3.58832 8.66963 3.08762 8.08889 2.72044C7.52 2.35328 6.83259 2.16967 6.02667 2.16967C5.36296 2.16967 4.76445 2.32545 4.23111 2.637C3.69778 2.94853 3.28296 3.3936 2.98667 3.97218C2.69037 4.55076 2.54222 5.22948 2.54222 6.00834C2.54222 6.77608 2.69037 7.44924 2.98667 8.02782C3.28296 8.6064 3.69778 9.05147 4.23111 9.363C4.76445 9.67455 5.36296 9.83032 6.02667 9.83032C6.83259 9.83032 7.52 9.64672 8.08889 9.27955C8.66963 8.91238 9.0963 8.41168 9.3689 7.77747H12C11.6682 9.07928 10.9867 10.1085 9.95556 10.8651C8.92445 11.6217 7.62666 12 6.06222 12C4.86519 12 3.80445 11.7497 2.88 11.249C1.9674 10.7371 1.2563 10.025 0.746667 9.11265C0.248889 8.20027 0 7.16551 0 6.00834C0 4.84005 0.248889 3.79973 0.746667 2.88735C1.2563 1.97496 1.9674 1.26843 2.88 0.767733C3.7926 0.25591 4.85334 0 6.06222 0Z'
				fill={color}
			></path>
		</svg>
	);
};

export const SvgStar = ({ color = '#F7BF08', size = '14' }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox='0 0 14 13'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M13.1892 4.51714L9.22203 3.94058L7.44859 0.345269C7.40015 0.246832 7.32046 0.167144 7.22203 0.118707C6.97515 -0.00316804 6.67515 0.0983945 6.55171 0.345269L4.77828 3.94058L0.811089 4.51714C0.701714 4.53277 0.601714 4.58433 0.525151 4.66246C0.432592 4.75759 0.381587 4.88558 0.383345 5.0183C0.385103 5.15102 0.439479 5.27762 0.534526 5.37027L3.40484 8.16871L2.72671 12.1203C2.71081 12.2122 2.72098 12.3067 2.75608 12.3932C2.79117 12.4796 2.84978 12.5545 2.92526 12.6093C3.00074 12.6641 3.09007 12.6967 3.18312 12.7033C3.27617 12.71 3.36922 12.6904 3.45171 12.6468L7.00015 10.7812L10.5486 12.6468C10.6455 12.6984 10.758 12.7156 10.8658 12.6968C11.1377 12.65 11.3205 12.3921 11.2736 12.1203L10.5955 8.16871L13.4658 5.37027C13.5439 5.29371 13.5955 5.19371 13.6111 5.08433C13.6533 4.81089 13.4627 4.55777 13.1892 4.51714Z'
				fill={color}
			></path>
		</svg>
	)
}

export const CloseModalSvg = () => {
	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M9.21425 8L15.3666 0.666406C15.4697 0.544531 15.383 0.359375 15.2236 0.359375H13.3533C13.2432 0.359375 13.1377 0.408594 13.065 0.492969L7.99081 6.54219L2.91659 0.492969C2.84628 0.408594 2.74081 0.359375 2.62831 0.359375H0.758C0.598625 0.359375 0.511906 0.544531 0.615031 0.666406L6.76738 8L0.615031 15.3336C0.591931 15.3608 0.57711 15.394 0.57233 15.4293C0.56755 15.4647 0.57301 15.5006 0.588063 15.533C0.603116 15.5653 0.627129 15.5926 0.657252 15.6117C0.687375 15.6308 0.722341 15.6408 0.758 15.6406H2.62831C2.73847 15.6406 2.84394 15.5914 2.91659 15.507L7.99081 9.45781L13.065 15.507C13.1353 15.5914 13.2408 15.6406 13.3533 15.6406H15.2236C15.383 15.6406 15.4697 15.4555 15.3666 15.3336L9.21425 8Z'></path>
		</svg>
	)
}

export const DownArrowIcon = ({ width = 10, height = 6 }) => (
	<svg
		width={`${width}px`}
		height={`${height}px`}
		viewBox={`0 0 ${width} ${height}`}
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M4.52815 3.59656L1.10621 0.189756C0.853039 -0.0632521 0.442565 -0.0632521 0.189392 0.189756C-0.0637815 0.442765 -0.0637815 0.852972 0.189392 1.10598L4.06328 4.97735C4.18451 5.0995 4.34954 5.16821 4.52169 5.16821C4.69385 5.16821 4.85887 5.0995 4.9801 4.97735L8.85399 1.10598C9.10717 0.852972 9.10717 0.442765 8.85399 0.189756C8.60082 -0.0632521 8.19035 -0.0632521 7.93717 0.189756L4.52815 3.59656Z'
			fill='#0099F3'
		></path>
	</svg>
)

export const UpArrowIcon = ({ width = 10, height = 6 }) => (
	<svg
		width={`${width}px`}
		height={`${height}px`}
		viewBox={`0 0 ${width} ${height}`}
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M4.51531 1.57141L7.93724 4.97821C8.19042 5.23122 8.60089 5.23122 8.85407 4.97821C9.10724 4.7252 9.10724 4.315 8.85407 4.06199L4.98017 0.190619C4.85894 0.068469 4.69392 -0.000238419 4.52176 -0.000238419C4.34961 -0.000238419 4.18458 0.068469 4.06335 0.190619L0.189463 4.06199C-0.0637102 4.315 -0.0637102 4.7252 0.189463 4.97821C0.442636 5.23122 0.85311 5.23122 1.10628 4.97821L4.51531 1.57141Z'
			fill='#0099F3'
		></path>
	</svg>
)

// eslint-disable-next-line no-unused-vars

export const TextIcon = ({
	color = OtColors.red,
	text = '',
	margin,
	size = 48, // Updated width
	...props
}) => {
	let topMargin = margin ? margin : '0'

	return (
		<svg
			style={{ marginTop: topMargin }}
			width={`${size}px`}
			height='24px'
			viewBox='0 0 48 22'
			{...props}
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g fillRule='nonzero' fill={color} className='ot_svg_fill'>
					<text
						x='0'
						y='15'
						fontSize='14'
						fill={color}
						fontFamily='Inter, sans-serif'
					>
						{text}
					</text>
				</g>
			</g>
		</svg>
	)
}
